export const foldedRoutes = ['/planning-proj/planning/book-employee'];
export const Document = ['DocumentId', 'Title', 'Link', 'Type'];
export const UserInfo = [
    'UserInfoId',
    'Name',
    'Avatar',
    'Roles',
    'PersonId',
    'EmployeeId'
];
export const DocumentCheckList = [...Document, 'IsProvided'];
export const Attachment = [{ AttachedBy: UserInfo }, ...Document];
export const DeltaCommonInfo = [
    'EntityId',
    'Title',
    'Description',
    'Code',
    'Image'
];
export enum DepartmentIds {
	DELTA = 'e14997a5-9ada-4d62-b94f-d7a471c24c5b',
	BASIC = 'b5403be4-f66f-4736-98f1-505a0cba3682',
	ServX = 'c7684ada-fa1f-4e1a-a2d7-ed8bfa53863c',
	CrewX = '7c8efea4-163f-4ebb-9bc0-24bb4838c3b6',
	DELTA_Academy = '638c87b3-0db2-4e0f-ae69-739e6b9d0671',
	AbtID = '67ef894a-6c97-4d3e-9610-246b002860be',
	DELTAgroup = '700fa131-8d8b-4834-bed0-8013e47cdb2a',
}
export const DeltaProjectClient = [...DeltaCommonInfo, 'BranchId'];
export const ProjectClientDetail = [
    ...DeltaCommonInfo,
    'ParentId',
    'ClientAddress',
    'DisplayTitle'
];
export const AddressInfo = [
    'Address',
    'Country',
    'State',
    'City',
    'Street',
    'Street_Number',
    'Postal_Code',
    'Country_Code',
    'MapUrl',
    'Lat',
    'Lng',
    'Description',
    'House_Number',
    'Type'
];
export const ProjectContactDetail = [
    'ContactInfoId',
    'PersonId',
    'Name',
    'Email',
    'MobileNumber',
    'MobileCountryCode'
];
export const ProductCostDetail = [
    'ArticleQuantity',
    'KBaseOneAmount',
    'KBaseTwoAmount',
    'ArticleInternalUnitPrice',
    'ArticleExternalUnitPrice',
    'ArticleDiscountPercentage',
    'ArticleExternalFinalAmount',
    'ArticleInternalFinalAmount',
    'ArticleDescription'
];
export const ProductSurchargeInfo = [
    'SurchargeType',
    'ArticleId',
    'ArticleDescription',
    'ArticleQuantity',
    'ArticleHour',
    'ArticleQuantifiedValue'
];
export const BillingAddress = [
    'Address',
    'Country',
    'State',
    'City',
    'House_Number',
    'Street',
    'Street_Number',
    'Postal_Code',
    'Country_Code',
    'MapUrl',
    'Type',
    'Lat',
    'Lng',
    'Description'
];

export const DailyProjectInfoPartial = ['DailyProjectId', 'Title'];

export const MultiTypeKeyValue = [
    'ItemKey',
    'NumberValue',
    'TextValue',
    'BoolValue',
    'ValueType'
];

export const Educations = [
    'ItemId',
    'Degree',
    'Grade',
    'StartYear',
    'EndYear',
    'FieldOfStudy',
    'IsStillStudying',
    { Institution: ['Name', 'ItemId'] }
];
export const Country = ['ItemId', 'ShortCode', 'Name', 'IsoCode'];
export const Addresses = [
    'ItemId',
    'AddressLine',
    'Street',
    'PostalCode',
    'Locality',
    'City',
    'State',
    'Type',
    'Description',
    { Country }
];
export const Nationality = ['ItemId', { Country }, 'Name'];
export const Employments = [
    'ItemId',
    'Industry',
    'EmployedSince',
    'Designation',
    'EmployedTill',
    'IsStillWorking',
    { Company: ['ItemId', 'Name'] },
    { Location: Addresses }
];
export const OtherDocuments = [
    'ItemId',
    'Type',
    'Name',
    'FileUrl',
    'FileId',
    'CreateDate'
];
export const Emails = ['Email', 'Type', 'ItemId'];
export const PhoneNumbers = ['Phone', 'Type', 'ItemId', 'Name', 'Description'];
export const FamilyMembers = [
    'ItemId',
    'Name',
    'Relationship',
    'DateOfBirth',
    { Emails },
    { PhoneNumbers },
    'Sex',
    'ImageFileId'
];
export const IdentityImages = ['ItemId', 'FileId', 'FileUrl'];
export const Identifications = [
    'ItemId',
    'IdentificationNo',
    'Type',
    { IssuedPlace: Addresses },
    'IssuedDate',
    'ValidityDate',
    { Images: IdentityImages }
];
export const ContactInformationDetail = [
    'ContactInfoId',
    'FirstName',
    'LastName',
    'DisplayName',
    'Salutation',
    'Emails',
    'PhoneNumbers',
    'PersonId',
    'LeadId',
    'Departments',
    'IsSameAsIndividual'
];
export const WorkableProductInformation = [
    'AssignmentDate',
    'StartTime',
    'EndTime',
    'StartDateTime',
    'EndDateTime',
    'ProductId',
    'ProjectId',
    'ProjectName',
    'ArticleId',
    'ArticleDescription'
];
export const IndividualScore = ['ScoreKey', 'ScoreValue'];
export const DefaultCurrency = ['Name', 'Code', 'Symbol'];
export const Connection = [
    'ConnectionId',
    'ConnectionType',
    'GroupName',
    'ConnectionRoles'
];
export const Documents = ['FileId', 'Name'];
export const ContactInformation = [
    'ContactInfoId',
    'Name',
    'Email',
    'PhoneCountryCode',
    'PhoneNumber',
    'PersonId'
];
export const TransactionInfo = ['Name', 'PersonId', 'UserInfoId'];
export const TransferredItems = ['InventoryTransectionItemId', 'InventoryItemId', 'InventoryItemName', 'Quantity'];
export const TransferHistories = ['TransferDateTime', 'NotificationDateTime', 'NotifyComment', 'IsAcknowledged', 'AcknowledgementDateTime', {TransferredItems: TransferredItems}];
export const TermsAndConditionsPDF = '9df7799c-397b-4598-84fd-95a8196e219d';
export const ReportTemplateFileIds = {
    HeaderId: 'd9112d37-8b0d-45bd-9352-dae785853e68',
    FooterId: 'e7fcb6af-3a0f-4677-86d7-1f627afeff67',
    AddressList: 'da012786-f831-4c79-b26e-6cb5d9018a53',
    OpenPositions: '3975fc29-942a-4fd4-8d02-bf8a754fb361',
    AddressListBasic: '4b5cfda1-c2cb-488d-b03f-1a9f21a11c6a',
    OrderOverview: '5c4a7cb3-cf38-4d52-a0da-7b61a48a63ca',
    OfferTerms: '2005185f-9290-488a-8dbd-08906f6f24f9',
    OderHeaderId: '43b7904e-5280-44a9-8fee-c15e96891c67',
    OfferHeader: '9bf31551-edc8-4ab4-917f-29063700d436',
    ManPower: 'ed798252-9809-4b2c-bc7c-7eca568b6545',
    DateAndTitleHeader: '6a5aa171-ee69-412a-8b7c-ce50814c00b1',
    ActionReportMultiProj: 'dbf58811-8eaf-49eb-a826-5659954e0beb',
    DeploymentComposition: '122f021b-2e19-4f20-a31b-877b73195d9e',
    ActionReportMultiProjExternal: 'c212aa01-d18d-47b0-afad-993ffe96375e',
    Pikettdossier: '43d53834-8f2b-4b82-b0c5-68caa7c865fb',
    InfoMeeting: '1966dabc-c91d-4343-b8ed-871854a71b8c',
    evaluationTemplateId: '00003d00-af2c-4b24-aeaf-c9a878afff95',
    ActionReportFooter: 'a71f4785-3692-4990-a215-bb5f1bd6bd53',
    ManPowerReportHeader: '1a1c17ac-b907-455a-a489-dcafd660d831',
    ManPowerReportContent: '9ad7f0cc-5482-4b17-9096-8cd56b440f85',
    ActionReportHeader: 'f41e9c9e-a8f1-448a-a2f1-d9c1e1336564',
    ActionReportContent: 'dbdfe9da-fadd-4ea3-b1bf-59c35a6f27b1',
    IncidentReportHeader: 'f64b9c83-ced0-4f50-b619-9e0c24904202',
    IncidentReportContent: '1510abc5-4879-4351-b290-5a4ece911bc0',
    IncidentReportFooter: '4614a655-40d2-4239-b673-7c46ca2c3700',
    PaymentReceiptBody: 'caf942db-e6ae-4345-aa80-8c4967747d19',
    GeneratedOfferBody: '758f8016-c453-4e5d-adcc-8319a5151a06'
};
export const Months = [
    { key: 'JANUARY', value: 1 },
    { key: 'FEBRUARY', value: 2 },
    { key: 'MARCH', value: 3 },
    { key: 'APRIL', value: 4 },
    { key: 'MAY', value: 5 },
    { key: 'JUNE', value: 6 },
    { key: 'JULY', value: 7 },
    { key: 'AUGUST', value: 8 },
    { key: 'SEPTEMBER', value: 9 },
    { key: 'OCTOBER', value: 10 },
    { key: 'NOVEMBER', value: 11 },
    { key: 'DECEMBER', value: 12 }
];
export const NationalityEn = [
    { Key: 'Swiss', Value: 'Swiss' },
    { Key: 'French', Value: 'French' },
    { Key: 'Italian', Value: 'Italian' },
    {
        Key: 'German',
        Value: 'German'
    },
    { Key: 'Austrian', Value: 'Austrian' },
    { Key: 'Afghan', Value: 'Afghan' },
    { Key: 'Albanian', Value: 'Albanian' },
    {
        Key: 'Algerian',
        Value: 'Algerian'
    },
    { Key: 'Argentinian', Value: 'Argentinian' },
    { Key: 'Australian', Value: 'Australian' },
    {
        Key: 'Bangladeshi',
        Value: 'Bangladeshi'
    },
    { Key: 'Belgian', Value: 'Belgian' },
    { Key: 'Bolivian', Value: 'Bolivian' },
    { Key: 'Batswana', Value: 'Batswana' },
    {
        Key: 'Brazilian',
        Value: 'Brazilian'
    },
    { Key: 'Bulgarian', Value: 'Bulgarian' },
    { Key: 'Cambodian', Value: 'Cambodian' },
    {
        Key: 'Cameroonian',
        Value: 'Cameroonian'
    },
    { Key: 'Canadian', Value: 'Canadian' },
    { Key: 'Chilean', Value: 'Chilean' },
    { Key: 'Chinese', Value: 'Chinese' },
    {
        Key: 'Colombian',
        Value: 'Colombian'
    },
    { Key: 'Costa Rican', Value: 'Costa Rican' },
    { Key: 'Croatian', Value: 'Croatian' },
    { Key: 'Cuban', Value: 'Cuban' },
    {
        Key: 'Czech',
        Value: 'Czech'
    },
    { Key: 'Danish', Value: 'Danish' },
    { Key: 'Dominican', Value: 'Dominican' },
    { Key: 'Ecuadorian', Value: 'Ecuadorian' },
    {
        Key: 'Egyptian',
        Value: 'Egyptian'
    },
    { Key: 'Salvadorian', Value: 'Salvadorian' },
    { Key: 'English', Value: 'English' },
    {
        Key: 'Estonian',
        Value: 'Estonian'
    },
    { Key: 'Ethiopian', Value: 'Ethiopian' },
    { Key: 'Fijian', Value: 'Fijian' },
    { Key: 'Finnish', Value: 'Finnish' },
    {
        Key: 'Ghanaian',
        Value: 'Ghanaian'
    },
    { Key: 'Greek', Value: 'Greek' },
    { Key: 'Guatemalan', Value: 'Guatemalan' },
    { Key: 'Haitian', Value: 'Haitian' },
    {
        Key: 'Honduran',
        Value: 'Honduran'
    },
    { Key: 'Hungarian', Value: 'Hungarian' },
    { Key: 'Icelandic', Value: 'Icelandic' },
    { Key: 'Indian', Value: 'Indian' },
    {
        Key: 'Indonesian',
        Value: 'Indonesian'
    },
    { Key: 'Iranian', Value: 'Iranian' },
    { Key: 'Iraqi', Value: 'Iraqi' },
    { Key: 'Irish', Value: 'Irish' },
    {
        Key: 'Israeli',
        Value: 'Israeli'
    },
    { Key: 'Jamaican', Value: 'Jamaican' },
    { Key: 'Japanese', Value: 'Japanese' },
    { Key: 'Jordanian', Value: 'Jordanian' },
    {
        Key: 'Kenyan',
        Value: 'Kenyan'
    },
    { Key: 'Kuwaiti', Value: 'Kuwaiti' },
    { Key: 'Lao', Value: 'Lao' },
    { Key: 'Latvian', Value: 'Latvian' },
    {
        Key: 'Lebanese',
        Value: 'Lebanese'
    },
    { Key: 'Libyan', Value: 'Libyan' },
    { Key: 'Lithuanian', Value: 'Lithuanian' },
    { Key: 'Malagasy', Value: 'Malagasy' },
    {
        Key: 'Malaysian',
        Value: 'Malaysian'
    },
    { Key: 'Malian', Value: 'Malian' },
    { Key: 'Maltese', Value: 'Maltese' },
    { Key: 'Mexican', Value: 'Mexican' },
    {
        Key: 'Mongolian',
        Value: 'Mongolian'
    },
    { Key: 'Moroccan', Value: 'Moroccan' },
    { Key: 'Mozambican', Value: 'Mozambican' },
    {
        Key: 'Namibian',
        Value: 'Namibian'
    },
    { Key: 'Nepalese', Value: 'Nepalese' },
    { Key: 'Dutch', Value: 'Dutch' },
    { Key: 'New Zealand', Value: 'New Zealand' },
    {
        Key: 'Nicaraguan',
        Value: 'Nicaraguan'
    },
    { Key: 'Nigerian', Value: 'Nigerian' },
    { Key: 'Norwegian', Value: 'Norwegian' },
    {
        Key: 'Pakistani',
        Value: 'Pakistani'
    },
    { Key: 'Panamanian', Value: 'Panamanian' },
    { Key: 'Paraguayan', Value: 'Paraguayan' },
    {
        Key: 'Peruvian',
        Value: 'Peruvian'
    },
    { Key: 'Philippine', Value: 'Philippine' },
    { Key: 'Polish', Value: 'Polish' },
    {
        Key: 'Portuguese',
        Value: 'Portuguese'
    },
    { Key: 'Romanian', Value: 'Romanian' },
    { Key: 'Russian', Value: 'Russian' },
    { Key: 'Saudi', Value: 'Saudi' },
    {
        Key: 'Scottish',
        Value: 'Scottish'
    },
    { Key: 'Senegalese', Value: 'Senegalese' },
    { Key: 'Serbian', Value: 'Serbian' },
    {
        Key: 'Singaporean',
        Value: 'Singaporean'
    },
    { Key: 'Slovak', Value: 'Slovak' },
    { Key: 'South African', Value: 'South African' },
    { Key: 'Korean', Value: 'Korean' },
    {
        Key: 'Spanish',
        Value: 'Spanish'
    },
    { Key: 'Sri Lankan', Value: 'Sri Lankan' },
    { Key: 'Sudanese', Value: 'Sudanese' },
    { Key: 'Swedish', Value: 'Swedish' },
    {
        Key: 'Syrian',
        Value: 'Syrian'
    },
    { Key: 'Taiwanese', Value: 'Taiwanese' },
    { Key: 'Tajikistani', Value: 'Tajikistani' },
    { Key: 'Thai', Value: 'Thai' },
    {
        Key: 'Tongan',
        Value: 'Tongan'
    },
    { Key: 'Tunisian', Value: 'Tunisian' },
    { Key: 'Turkish', Value: 'Turkish' },
    { Key: 'Ukrainian', Value: 'Ukrainian' },
    {
        Key: 'Emirati',
        Value: 'Emirati'
    },
    { Key: 'British', Value: 'British' },
    { Key: 'American', Value: 'American' },
    { Key: 'Uruguayan', Value: 'Uruguayan' },
    {
        Key: 'Venezuelan',
        Value: 'Venezuelan'
    },
    { Key: 'Vietnamese', Value: 'Vietnamese' },
    { Key: 'Welsh', Value: 'Welsh' },
    { Key: 'Zambian', Value: 'Zambian' },
    {
        Key: 'Zimbabwean',
        Value: 'Zimbabwean'
    }
];

export const NationalityDe = [
    { Key: 'Swiss', Value: 'Schweizer' },
    { Key: 'French', Value: 'Französisch' },
    { Key: 'Italian', Value: 'Italienisch' },
    {
        Key: 'German',
        Value: 'Deutsch'
    },
    { Key: 'Austrian', Value: 'Österreichisch' },
    { Key: 'Afghan', Value: 'Afghanisch' },
    {
        Key: 'Albanian',
        Value: 'Albanisch'
    },
    { Key: 'Algerian', Value: 'Algerisch' },
    { Key: 'Argentinian', Value: 'argentinisch' },
    {
        Key: 'Australian',
        Value: 'Australisch'
    },
    { Key: 'Bangladeshi', Value: 'Bangladescher' },
    { Key: 'Belgian', Value: 'Belgisch' },
    {
        Key: 'Bolivian',
        Value: 'Bolivianisch'
    },
    { Key: 'Batswana', Value: 'Batswana' },
    { Key: 'Brazilian', Value: 'Brasilianisch' },
    {
        Key: 'Bulgarian',
        Value: 'Bulgarisch'
    },
    { Key: 'Cambodian', Value: 'Kambodschanisch' },
    { Key: 'Cameroonian', Value: 'Kamerunisch' },
    {
        Key: 'Canadian',
        Value: 'Kanadisch'
    },
    { Key: 'Chilean', Value: 'Chilenisch' },
    { Key: 'Chinese', Value: 'Chinesisch' },
    {
        Key: 'Colombian',
        Value: 'Kolumbianer'
    },
    { Key: 'Costa Rican', Value: 'Costa Ricaner' },
    { Key: 'Croatian', Value: 'Kroatisch' },
    {
        Key: 'Cuban',
        Value: 'Kubanisch'
    },
    { Key: 'Czech', Value: 'Tschechisch' },
    { Key: 'Danish', Value: 'Dänisch' },
    {
        Key: 'Dominican',
        Value: 'Dominikanisch'
    },
    { Key: 'Ecuadorian', Value: 'Ekuadorianisch' },
    { Key: 'Egyptian', Value: 'Ägyptisch' },
    {
        Key: 'Salvadorian',
        Value: 'Salvadorianisch'
    },
    { Key: 'English', Value: 'Englisch' },
    { Key: 'Estonian', Value: 'Estnisch' },
    { Key: 'Ethiopian', Value: 'Äthiopisch' },
    {
        Key: 'Fijian',
        Value: 'Fidschianisch'
    },
    { Key: 'Finnish', Value: 'Finnisch' },
    { Key: 'Ghanaian', Value: 'Ghanaisch' },
    { Key: 'Greek', Value: 'Griechisch' },
    {
        Key: 'Guatemalan',
        Value: 'Guatemaltekisch'
    },
    { Key: 'Haitian', Value: 'Haitianisch' },
    { Key: 'Honduran', Value: 'honduranisch' },
    {
        Key: 'Hungarian',
        Value: 'Ungarisch'
    },
    { Key: 'Icelandic', Value: 'Isländisch' },
    { Key: 'Indian', Value: 'Indisch' },
    {
        Key: 'Indonesian',
        Value: 'Indonesisch'
    },
    { Key: 'Iranian', Value: 'iranisch' },
    { Key: 'Iraqi', Value: 'Irakisch' },
    { Key: 'Irish', Value: 'Irisch' },
    {
        Key: 'Israeli',
        Value: 'Israelisch'
    },
    { Key: 'Jamaican', Value: 'Jamaikanisch' },
    { Key: 'Japanese', Value: 'Japanisch' },
    {
        Key: 'Jordanian',
        Value: 'Jordanisch'
    },
    { Key: 'Kenyan', Value: 'Kenianisch' },
    { Key: 'Kuwaiti', Value: 'Kuwaitisch' },
    { Key: 'Lao', Value: 'Laotisch' },
    {
        Key: 'Latvian',
        Value: 'Lettisch'
    },
    { Key: 'Lebanese', Value: 'Libanon' },
    { Key: 'Libyan', Value: 'Libysch' },
    { Key: 'Lithuanian', Value: 'Litauisch' },
    {
        Key: 'Malagasy',
        Value: 'Madagassisch'
    },
    { Key: 'Malaysian', Value: 'malaysisch' },
    { Key: 'Malian', Value: 'Malisch' },
    { Key: 'Maltese', Value: 'Maltesisch' },
    {
        Key: 'Mexican',
        Value: 'Mexikanisch'
    },
    { Key: 'Mongolian', Value: 'Mongolisch' },
    { Key: 'Moroccan', Value: 'Marokkanisch' },
    {
        Key: 'Mozambican',
        Value: 'Mosambikanisch'
    },
    { Key: 'Namibian', Value: 'Namibier' },
    { Key: 'Nepalese', Value: 'Nepalesisch' },
    {
        Key: 'Dutch',
        Value: 'Niederländisch'
    },
    { Key: 'New Zealand', Value: 'neuseeländisch' },
    { Key: 'Nicaraguan', Value: 'Nicaragua' },
    {
        Key: 'Nigerian',
        Value: 'Nigerianer'
    },
    { Key: 'Norwegian', Value: 'Norwegisch' },
    { Key: 'Pakistani', Value: 'pakistanisch' },
    {
        Key: 'Panamanian',
        Value: 'panamaisch'
    },
    { Key: 'Paraguayan', Value: 'paraguayisch' },
    { Key: 'Peruvian', Value: 'Peruanisch' },
    {
        Key: 'Philippine',
        Value: 'philippinisch'
    },
    { Key: 'Polish', Value: 'Polnisch' },
    { Key: 'Portuguese', Value: 'Portugiesisch' },
    {
        Key: 'Romanian',
        Value: 'Rumänisch'
    },
    { Key: 'Russian', Value: 'Russisch' },
    { Key: 'Saudi', Value: 'Saudisch' },
    { Key: 'Scottish', Value: 'Schottisch' },
    {
        Key: 'Senegalese',
        Value: 'Senegalesisch'
    },
    { Key: 'Serbian', Value: 'serbisch' },
    { Key: 'Singaporean', Value: 'Singapurisch' },
    {
        Key: 'Slovak',
        Value: 'Slowake'
    },
    { Key: 'South African', Value: 'Südafrikaner' },
    { Key: 'Korean', Value: 'Koreanisch' },
    {
        Key: 'Spanish',
        Value: 'Spanisch'
    },
    { Key: 'Sri Lankan', Value: 'srilankisch' },
    { Key: 'Sudanese', Value: 'Sudanisch' },
    {
        Key: 'Swedish',
        Value: 'Schwedisch'
    },
    { Key: 'Syrian', Value: 'Syrisch' },
    { Key: 'Taiwanese', Value: 'Taiwaner' },
    {
        Key: 'Tajikistani',
        Value: 'Tadschikistaner'
    },
    { Key: 'Thai', Value: 'Thailändisch' },
    { Key: 'Tongan', Value: 'Tongaer' },
    { Key: 'Tunisian', Value: 'Tunesisch' },
    {
        Key: 'Turkish',
        Value: 'Türkisch'
    },
    { Key: 'Ukrainian', Value: 'Ukrainisch' },
    { Key: 'Emirati', Value: 'emiratisch' },
    {
        Key: 'British',
        Value: 'Britisch'
    },
    { Key: 'American', Value: 'Amerikaner**' },
    { Key: 'Uruguayan', Value: 'Uruguayer' },
    {
        Key: 'Venezuelan',
        Value: 'Venezolanisch'
    },
    { Key: 'Vietnamese', Value: 'Vietnamesisch' },
    { Key: 'Welsh', Value: 'Walisisch' },
    {
        Key: 'Zambian',
        Value: 'Sambier'
    },
    { Key: 'Zimbabwean', Value: 'Simbabwisch' }
];

export const NationalityIt = [
    { Key: 'Swiss', Value: 'Svizzero' },
    { Key: 'French', Value: 'Francese' },
    { Key: 'Italian', Value: 'Italiano' },
    {
        Key: 'German',
        Value: 'Tedesco'
    },
    { Key: 'Austrian', Value: 'Austriaco' },
    { Key: 'Afghan', Value: 'Afghan' },
    { Key: 'Albanian', Value: 'Albanese' },
    {
        Key: 'Algerian',
        Value: 'Algerino'
    },
    { Key: 'Argentinian', Value: 'Argentino' },
    { Key: 'Australian', Value: 'Australiano' },
    {
        Key: 'Bangladeshi',
        Value: 'Bangladesh'
    },
    { Key: 'Belgian', Value: 'Belga' },
    { Key: 'Bolivian', Value: 'Boliviano' },
    { Key: 'Batswana', Value: 'Batswana' },
    {
        Key: 'Brazilian',
        Value: 'Brasiliano'
    },
    { Key: 'Bulgarian', Value: 'Bulgaro' },
    { Key: 'Cambodian', Value: 'Cambogiano' },
    {
        Key: 'Cameroonian',
        Value: 'Camerunese'
    },
    { Key: 'Canadian', Value: 'Canadese' },
    { Key: 'Chilean', Value: 'Cileno' },
    { Key: 'Chinese', Value: 'Cinese' },
    {
        Key: 'Colombian',
        Value: 'Colombiano'
    },
    { Key: 'Costa Rican', Value: 'costaricano' },
    { Key: 'Croatian', Value: 'Croato' },
    { Key: 'Cuban', Value: 'Cubano' },
    {
        Key: 'Czech',
        Value: 'Ceco'
    },
    { Key: 'Danish', Value: 'Danese' },
    { Key: 'Dominican', Value: 'Domenicano' },
    {
        Key: 'Ecuadorian',
        Value: 'Ecuadoriano'
    },
    { Key: 'Egyptian', Value: 'Egiziano' },
    { Key: 'Salvadorian', Value: 'Salvadoriano' },
    {
        Key: 'English',
        Value: 'Inglese'
    },
    { Key: 'Estonian', Value: 'Estone' },
    { Key: 'Ethiopian', Value: 'Etiope' },
    { Key: 'Fijian', Value: 'Fijian' },
    {
        Key: 'Finnish',
        Value: 'Finlandese'
    },
    { Key: 'Ghanaian', Value: 'Ghanese' },
    { Key: 'Greek', Value: 'Greco' },
    { Key: 'Guatemalan', Value: 'Guatemala' },
    {
        Key: 'Haitian',
        Value: 'Haitiano'
    },
    { Key: 'Honduran', Value: 'Honduras' },
    { Key: 'Hungarian', Value: 'Ungherese' },
    { Key: 'Icelandic', Value: 'Islandese' },
    {
        Key: 'Indian',
        Value: 'Indiano'
    },
    { Key: 'Indonesian', Value: 'Indonesiano' },
    { Key: 'Iranian', Value: 'Iraniano' },
    { Key: 'Iraqi', Value: 'Iracheno' },
    {
        Key: 'Irish',
        Value: 'Irlandese'
    },
    { Key: 'Israeli', Value: 'Israeliano' },
    { Key: 'Jamaican', Value: 'Giamaicano' },
    {
        Key: 'Japanese',
        Value: 'Giapponese'
    },
    { Key: 'Jordanian', Value: 'Giordano' },
    { Key: 'Kenyan', Value: 'Keniota' },
    { Key: 'Kuwaiti', Value: 'Kuwait' },
    {
        Key: 'Lao',
        Value: 'Lao'
    },
    { Key: 'Latvian', Value: 'Lettone' },
    { Key: 'Lebanese', Value: 'Libanese' },
    { Key: 'Libyan', Value: 'Libico' },
    {
        Key: 'Lithuanian',
        Value: 'Lituano'
    },
    { Key: 'Malagasy', Value: 'Malgascio' },
    { Key: 'Malaysian', Value: 'Malese' },
    { Key: 'Malian', Value: 'Maliano' },
    {
        Key: 'Maltese',
        Value: 'Maltese'
    },
    { Key: 'Mexican', Value: 'Messicano' },
    { Key: 'Mongolian', Value: 'Mongolo' },
    {
        Key: 'Moroccan',
        Value: 'Marocchino'
    },
    { Key: 'Mozambican', Value: 'Mozambicana' },
    { Key: 'Namibian', Value: 'Namibiano' },
    {
        Key: 'Nepalese',
        Value: 'Nepalese'
    },
    { Key: 'Dutch', Value: 'Olandese' },
    { Key: 'New Zealand', Value: 'neozelandese' },
    {
        Key: 'Nicaraguan',
        Value: 'Nicaraguense'
    },
    { Key: 'Nigerian', Value: 'Nigeriano' },
    { Key: 'Norwegian', Value: 'Norvegese' },
    {
        Key: 'Pakistani',
        Value: 'Pakistano'
    },
    { Key: 'Panamanian', Value: 'Panamense' },
    { Key: 'Paraguayan', Value: 'Paraguaiano' },
    {
        Key: 'Peruvian',
        Value: 'Peruviano'
    },
    { Key: 'Philippine', Value: 'Filippino' },
    { Key: 'Polish', Value: 'Polacco' },
    {
        Key: 'Portuguese',
        Value: 'Portoghese'
    },
    { Key: 'Romanian', Value: 'Rumeno' },
    { Key: 'Russian', Value: 'Russo' },
    { Key: 'Saudi', Value: 'Saudita' },
    {
        Key: 'Scottish',
        Value: 'Scozzese'
    },
    { Key: 'Senegalese', Value: 'Senegalese' },
    { Key: 'Serbian', Value: 'Serbo' },
    {
        Key: 'Singaporean',
        Value: 'Singaporeano'
    },
    { Key: 'Slovak', Value: 'Slovacco' },
    { Key: 'South African', Value: 'Sudafricano' },
    { Key: 'Korean', Value: 'Coreano' },
    {
        Key: 'Spanish',
        Value: 'Spagnolo'
    },
    { Key: 'Sri Lankan', Value: 'Sri Lanka' },
    { Key: 'Sudanese', Value: 'Sudanese' },
    { Key: 'Swedish', Value: 'Svedese' },
    {
        Key: 'Syrian',
        Value: 'Siriano'
    },
    { Key: 'Taiwanese', Value: 'Taiwanese' },
    { Key: 'Tajikistani', Value: 'Tajikistani' },
    {
        Key: 'Thai',
        Value: 'Thailandese'
    },
    { Key: 'Tongan', Value: 'Tongan' },
    { Key: 'Tunisian', Value: 'Tunisino' },
    { Key: 'Turkish', Value: 'Turco' },
    {
        Key: 'Ukrainian',
        Value: 'Ucraino'
    },
    { Key: 'Emirati', Value: 'Emirati' },
    { Key: 'British', Value: 'Britannico' },
    { Key: 'American', Value: 'Americano' },
    {
        Key: 'Uruguayan',
        Value: 'Uruguaiano'
    },
    { Key: 'Venezuelan', Value: 'Venezuelano' },
    { Key: 'Vietnamese', Value: 'Vietnamita' },
    {
        Key: 'Welsh',
        Value: 'Gallese'
    },
    { Key: 'Zambian', Value: 'Zambiano' },
    { Key: 'Zimbabwean', Value: 'Zimbabwean' }
];

export const ProjectStatusList = [
    {
        id: 1,
        name: 'draft',
        lang_key: 'DRAFT',
        count: 0,
        icon: 'tune',
        visible: false
    },
    {
        id: 2,
        name: 'unplanned',
        lang_key: 'UNPLANNED',
        count: 0,
        icon: 'crop',
        visible: true
    },
    {
        id: 3,
        name: 'planning_ongoing',
        lang_key: 'PLANNING_ONGOING',
        count: 0,
        icon: 'loop',
        visible: true
    },
    {
        id: 4,
        name: 'planning_completed',
        lang_key: 'PLANNED',
        count: 0,
        icon: 'tune',
        visible: true
    },
    {
        id: 5,
        name: 'project_ongoing',
        lang_key: 'PROJECT_ONGOING',
        count: 0,
        icon: 'tune',
        visible: false
    },
    {
        id: 6,
        name: 'onsite_report_submitted',
        lang_key: 'ONSITE_REPORT_SUBMITTED',
        count: 0,
        icon: 'loop',
        visible: false
    },
    {
        id: 7,
        name: 'completed',
        lang_key: 'COMPLETED',
        count: 0,
        icon: 'done_all',
        visible: false
    }
];
export const DeltaClientBranchInfo = [
    'BranchId',
    'BranchName',
    { CorrespondenceAddress: AddressInfo },
    { BillingAddress: AddressInfo },
    'IsSimilarAsCorrespondenceAddress',
    { CorrespondenceContactInformation: ContactInformation },
    { BillingContactInformation: ContactInformation }
];
export const DeltaEmployeeInfo = [
    'EmployeeId',
    'PersonId',
    'Name',
    'ProfileImageId',
    'Roles'
];
export const OfferArticleDetail = [
    'ArticleDetailId',
    'ArticleId',
    'ArticleDescription',
    'ArticleCategory',
    'ArticleQuantity',
    'AddKbaseCalculation',
    'ArticleExternalUnitPrice',
    'CompetenceSurcharges',
    'ArticleInternalUnitPrice',
    'ArticleDiscountPercentage',
    'ArticleDiscountFinalAmount',
    'ArticleInternalFinalAmount',
    'ArticleExternalFinalAmount',
    'ArticleExternalFinalAmountIncludingDiscount',
    'KBaseOneAmount',
    'KBaseTwoAmount'
];

export const OfferArticleDetailOnsiteOffer = [
    'ArticleDetailId',
    'ArticleId',
    'ArticleDescription',
    'AccountingGroup',
    'ArticleCategory',
    'ArticleQuantity',
    'AddKbaseCalculation',
    'ArticleExternalUnitPrice',
    'CompetenceSurcharges',
    'ArticleInternalUnitPrice',
    'ArticleDiscountPercentage',
    'ArticleDiscountFinalAmount',
    'ArticleInternalFinalAmount',
    'ArticleExternalFinalAmount',
    'ArticleExternalFinalAmountIncludingDiscount',
    'KBaseOneAmount',
    'KBaseTwoAmount'
];

export const payrollWorkAdjustmentsDetails = [
    'Title',
    'Key',
    'Type',
    'Category',
    'Unit',
    'Quantity',
    'UnitPrice',
    'Amount',
    'IsNegetive'
];

export const payrollPerfornamceAdjustments = [
    'Title',
    'Key',
    'Type',
    'Category',
    'Unit',
    'Quantity',
    'UnitPrice',
    'Amount'
];
export const OnsiteRoleInformations = [
    'RoleId',
    'RoleKey',
    'Title',
    'StartTimeInSeconds',
    'EndTimeInSeconds',
    'IsCurrentRole',
    'AssignedBy',
    'AssignedFrom'
];
export const QualityEmployee = [
    'EmployeeId',
    'PersonId',
    'Name',
    'ProfileImageId',
    'Roles'
];
export const OfferDressCode = ['TenueCode', 'ItemGroup', 'Description', 'Title'];
export const OfferCosts = [
    'ArticleQuantity',
    'KBaseOneAmount',
    'KBaseTwoAmount',
    'ArticleDescription',
    'ArticleInternalUnitPrice',
    'ArticleExternalUnitPrice',
    'ArticleDiscountPercentage',
    'ArticleExternalFinalAmount',
    'ArticleInternalFinalAmount'
];
export const OfferItemRequestInfo = ['ItemId', 'ItemName', 'Quantity'];
export const CustomOfferItem = [
    'OfferArticleId',
    { Dress: OfferDressCode },
    'InternalNote',
    'CustomerNote',
    { OfferArticle: OfferArticleDetail },
    { Transportation: OfferItemRequestInfo },
    { Transportations: OfferItemRequestInfo },
    'RadioApplicable'
];
export const OfferArticleInfo = [
    { CantonDetail: OfferArticleDetail },
    'ArticleDate',
    'ArticleGroupId',
    'ArticleGroup',
    'StartTime',
    'EndTime',
    'WorkingHour',
    'OverNightJob',
    'FoodApplicable',
    'RadioApplicable',
    { FoodItem: OfferArticleDetail },
    { RadioCost: OfferArticleDetail },
    'Distance',
    { DistanceCost: OfferArticleDetail },
    { TransportationCosts: OfferArticleDetail },
    { OfferArticles: CustomOfferItem },
    { ProductArticles: CustomOfferItem },
    { SurchargeCosts: OfferArticleDetail },
    'InternalNote',
    'CustomerNote',
    'RecurrentDate',
    'SubTotal',
    'SubTotalOfDiscount',
    'SubTotalOfKBaseOneAmount',
    'SubTotalOfKBaseTwoAmount',
    'Staggering',
    'OfferArticleInfoId'
];
export const OfferArticle = [
    { OfferArticleInfos: OfferArticleInfo },
    'SubTotal',
    'TotalVat',
    'TotalAmount',
    'DiscountAmount',
    'Vat',
    'TotalRevenuePercentage',
    'TotalKBaseTwoAmount',
    'TotalRevenueAmount'
];
export const ProjectPlanningInfo = [
    'OfferArticleInfoId',
    'OfferArticleId',
    'ProgressStatus',
    'Deadline',
    'EmSegmentations',
    'HrSegmentations',
    'DocumentIdList',
    'MailDocumentIdList'
];
export const DateTimeRange = [
    'StartDateTime',
    'EndDateTime',
    'ItemId',
    'Note',
    'Title',
    'IsSystemGenerated'
];
export const ProjectAssignee = [
    'AssigneeId',
    { Employee: DeltaEmployeeInfo },
    { DateRange: DateTimeRange },
    'Status',
    'OfferArticleInfoId',
    'OfferArticleId',
    'InvitationDate',
    'AcceptDate',
    'RejectionDate',
    'RejectionReason',
    'ConfirmationDate',
    'IsExtraRequested'
];
export const ProjectMaterialInfo = [
    { DateRange: DateTimeRange },
    'OfferArticleId',
    'OfferArticleInfoId',
    'MaterialId',
    'Quantity',
    'PaymentStatus'
];
export const ProjectVehicleInfo = [
    'VehicleId',
    'VehicleTitle',
    { DateRange: DateTimeRange },
    'OfferArticleId',
    'OfferArticleInfoId',
    'IsPlanned',
    'IsAdditional',
    'VehicleType',
    'Price'
];

export const projectVehicleEmployees = [
    'EmployeeId',
    'VehicleId',
    'DepartureTime',
    'IsDriver',
    'BoardingPlace',
    'Note'
];

export const ProjectOfferArticleInfoStatus = [
    'OfferArticleInfoId',
    'IsPlanningComplete'
];
export const OfferArticle_Nested_ForEmployee = [
    'ArticleId',
    'ArticleDescription',
    'ArticleCategory'
];
export const OfferArticles_ForEmployee = [
    'OfferArticleId',
    'RadioApplicable',
    'InternalNote',
    'ArticleGroup',
    { Dress: OfferDressCode },
    { Transportations: OfferItemRequestInfo },
    { OfferArticle: OfferArticle_Nested_ForEmployee }
];
export const OfferArticleInfo_forEmployee = [
    // 'OfferArticleInfoId',
    { OfferArticles: OfferArticles_ForEmployee }
    // {Dress: OfferDressCode}
];
export const OfferArticle_ForEmployee = [
    { OfferArticleInfos: OfferArticleInfo_forEmployee }
];

export const CustomKeyValue = ['Key', { Value: DeltaCommonInfo }];
export const CustomKeyValueDate = ['Key', { Value: DeltaCommonInfo }];
export const Activity = [
    'ActivityType',
    'Detail',
    'ActivityTime',
    { User: UserInfo }
];
export const QuestionAnswers = [
    'QuestionKey',
    'Question',
    'Answer',
    'AnswerValue',
    'Remark',
    'Section'
];
export const DeltaEmployeeChildren = [
    'ChildId',
    'FirstName',
    'LastName',
    'DisplayName',
    'Sex',
    'DateofBirth',
    'Education',
    'BirthCertificateNumber'
];
export const ArticleMeta = [
    'ArticleId',
    'ArticleUrl',
    'ArticleTitle',
    'MetaTitle',
    'MetaDescription',
    'MetaImage',
    'MetaSiteName',
    'MetaUrl'
];
export const SubField = [
    'FormId',
    'Title',
    'FieldType',
    'FieldKey',
    'IsVisibleToForm',
    'InputElementTypeTitle',
    'InputElementTypeTitle',
    'OptionalStringifylData'
];

export const EmployeeSchedule = [
    'ItemId',
    'TimeSlotPolicyType',
    'SchedulePriority',
    'ActiveDayOfTheWeek',
    'ActiveWeekDays',
    { ActiveDateRange: DateTimeRange },
    'ActiveSpecificDate',
    'StartTime',
    'EndTime',
    'LastModifiedDate',
    'IsMarkedForDelete',
    'CreatedDate'
];

export const DeltaCertificateDetail = ['CertificateId', 'FileId'];

export enum HiringStatus {
    applied = 'Applied',
    selected = 'Selected',
    interview_schedule = 'Interview Schedule',
    verification_ongoing = 'Verification Ongoing',
    hired = 'Hired'
}

export enum ScheduleStatus {
    INVITED = 'invited',
    ACCEPTED = 'accepted',
    REJECTED = 'rejected',
    RESERVED = 'reserved',
    BOOKED = 'booked',
    SCHEDULED = 'scheduled',
    PENDING = 'pending',
    LEAVE = 'leave',
    WORK = 'work'
}

export const RequiredDocs = [
    { key: 'Driving License', value: 'DRIVING_LICENSE' },
    { key: 'Training Certificate', value: 'TRAINING_CERTIFICATE' },
    { key: 'NID', value: 'NID' },
    { key: 'eTin', value: 'E_TIN' }
];
export const DeltaEmployeeCategory = [
    { key: 'A01', value: 'Type A01' },
    { key: 'A02', value: 'Type A02' },
    { key: 'A03', value: 'Type A03' },
    { key: 'A04', value: 'Type A04' },
    { key: 'A05', value: 'Type A05' },
    { key: 'A06', value: 'Type A06' },
    { key: 'A07', value: 'Type A07' },
    { key: 'A08', value: 'Type A08' },
    { key: 'A09', value: 'Type A09' },
    { key: 'A10', value: 'Type A10' },
    { key: 'A11', value: 'Type A11' },
    { key: 'A12', value: 'Type A12' },
    { key: 'A13', value: 'Type A13' },
    { key: 'B01', value: 'Type B01' },
    { key: 'B02', value: 'Type B02' },
    { key: 'B03', value: 'Type B03' },
    { key: 'B04', value: 'Type B04' },
    { key: 'B05', value: 'Type B05' },
    { key: 'B06', value: 'Type B06' },
    { key: 'C', value: 'Type C' },
    { key: 'Z01', value: 'Type Z01' },
    { key: 'Z02', value: 'Type Z02' },
    { key: 'Z03', value: 'Type Z03' }
];
export const Genders = [
    { key: 'male', value: 'Male' },
    { key: 'female', value: 'Female' },
    { key: 'mfd', value: 'MFD' }
];
export const CommonLanguages = [
    { key: 'ENGLISH', value: 'English' },
    { key: 'FRENCH', value: 'French' },
    { key: 'ITALIAN', value: 'Italian' },
    { key: 'GERMAN', value: 'German' },
    { key: 'SPANISH', value: 'Spanish' },
    { key: 'PORTUGUESE', value: 'Portuguese' },
    { key: 'GREEK', value: 'Greek' },
    { key: 'ALBANIAN', value: 'Albanian' },
    { key: 'SERBIAN', value: 'Serbian' },
    { key: 'CROATIAN', value: 'Croatian' },
    { key: 'TURKISH', value: 'Türkisch' },
    { key: 'POLISH', value: 'Polish' },
    { key: 'RUSSIAN', value: 'Russian' },
    { key: 'CHINESE', value: 'Chinese' }
];
export const ReasonForNotice = [
    'Ausbildung nicht bestanden',
    'Hat keine Zeit mehr',
    'Private Gründe / Wiedereintritt',
    'Stundensoll nicht erfüllt',
    'Personalbereinigung',
    'Langzeitausfälle',
    'Hat keine Lust mehr',
    'Mangel an Disziplin',
    'Nicht tolerierbares Verhalten',
    'Eintrag im ZR/BR',
    'Ü70',
    'Verstorben',
    'Diverses'
];
// export const Genders = [
// 	{ key: 'MALE', value: 'Male' },
// 	{ key: 'FEMALE', value: 'Female' },
// 	{ key: 'OTHER', value: 'Other' },
// 	{ key: 'NOT_SPECIFIED', value: 'Not Specified' },
// ];
export const DefaultCourseCover ='';
export const Certificates = [
    {
        TemplateId: ' d712ca61-4455-4c06-969a-79b597c0dee2',
        Name: 'New Certificate',
        Url: ''
    }
];
export const DeltaSpecificRoles = ['ofv', 'kuv', 'mav'];
export const MaritalStatus = [
    {
        key: 'single',
        value: 'SINGLE'
    },
    {
        key: 'married',
        value: 'MARRIED'
    },
    {
        key: 'divorced',
        value: 'DIVORCED'
    },
    {
        key: 'seperated',
        value: 'SEPERATED'
    },
    {
        key: 'widowed',
        value: 'WIDOWED'
    },
    {
        key: 'registeredPartnership',
        value: 'REGISTERED_PARTNERSHIP'
    }
];
export const DELTA_CONFIG = {
    TenantId: 'A54D6D82-61F6-4BD0-BAF8-BD06B0AD72FF',
    profileDefaultImage:'',
    Roles: {
        AppUser: 'appuser',
        Anonymous: 'anonymous',
        Admin: 'admin',
        HR_Member: 'hr_member',
        Delta_Employee: 'delta_employee',
        Delta_Planner: 'delta_planner',
        Delta_On_Site_Team_Leader: 'delta_on_site_team_leader',
        Em_Member: 'em_member'
    },
    ProfileImageUploaderConfig: {
        thumbnailHeight: 200,
        thumbnailWidth: 200,
        defaultImage: 'https://cdn.selise.biz/arc2/user.jpg',
        profileImage: true,
        allowedImageTypes: ['jpg', 'jpeg', 'png'],
        maxImageSize: 5 // Megabyte,
    },
    ParkingRegulations: [
        { value: 'Parking at own expense', title: 'Parking at own expense' },
        {
            value: 'Parking paid on receipt/agreement',
            title: 'Parking paid on receipt/agreement'
        },
        {
            value: 'Parking according to client',
            title: 'Parking according to client'
        }
    ],
    ScheduleType: [
        { viewValue: 'SPECIFIC', value: 4 },
        { viewValue: 'DAILY', value: 3 },
        { viewValue: 'WEEKLY', value: 2 }
    ],
    SchedulePriority: [
        { viewValue: 'HIGH', value: 5 },
        { viewValue: 'MID', value: 3 },
        { viewValue: 'LOW', value: 1 }
    ],
    UnavailableTimeOptions: [
        { key: 0, viewValue: 'WHOLE_DAY' },
        { key: 1, viewValue: 'MORNING' },
        { key: 2, viewValue: 'AFTERNOON' },
        { key: 3, viewValue: 'EVENING' },
        { key: 4, viewValue: 'NIGHT' }
    ],
    OFV: [
        { id: 'BIM', title: 'Biedermann Markus' },
        { id: 'BIR', title: 'Biedermann Ralph' },
        { id: 'EBL', title: 'Eberhard Linus' },
        { id: 'GRA', title: 'Gresch Alfred' },
        { id: 'HIF', title: 'Hitz Fabian' },
        { id: 'LEU', title: 'Lederer Urban' },
        { id: 'MAP', title: 'Manasseri Paolo' },
        { id: 'NMA', title: 'Nünlist Marco' },
        { id: 'POM', title: 'Poletti Marco' },
        { id: 'SCK', title: 'Schmitter Karl' },
        { id: 'SPF', title: 'Spuhler Florian' },
        { id: 'WUA', title: 'Wüthrich Anja' },
        { id: 'WUS', title: 'Wüthrich Stefan' }
    ],
    KUV: [
        { id: 'BIM', title: 'Biedermann Markus' },
        { id: 'EBL', title: 'Eberhard Linus' },
        { id: 'HIF', title: 'Hitz Fabian' },
        { id: 'LEU', title: 'Lederer Urban' },
        { id: 'MAP', title: 'Manasseri Paolo' },
        { id: 'NMA', title: 'Nünlist Marco' },
        { id: 'POM', title: 'Poletti Marco' },
        { id: 'SCK', title: 'Schmitter Karl' },
        { id: 'SPF', title: 'Spuhler Florian' },
        { id: 'WUA', title: 'Wüthrich Anja' },
        { id: 'WUS', title: 'Wüthrich Stefan' }
    ],
    MAV: [
        { id: 'DED', title: 'De Cristofaro Daniele' },
        { id: 'HIM', title: 'Hindermann Micha' },
        { id: 'GRA', title: 'Gresch Alfred' },
        { id: 'HIF', title: 'Hitz Fabian' },
        { id: 'MAP', title: 'Manasseri Paolo' },
        { id: 'NMA', title: 'Nünlist Marco' },
        { id: 'POM', title: 'Poletti Marco' },
        { id: 'SCK', title: 'Schmitter Karl' },
        { id: 'ScT', title: 'Scheiwiller Thomas' },
        { id: 'SPF', title: 'Spuhler Florian' },
        { id: 'WUA', title: 'Wüthrich Anja' },
        { id: 'WUS', title: 'Wüthrich Stefan' }
    ],
    ArticleTypes: [
        { value: 'Stunden', title: 'Stunden' },
        // { value: 'Zuschläge', title: 'Zuschläge' },
        // {
        // 	value: 'Fz-Entschädigungen/-Pauschalen',
        // 	title: 'Fz-Entschädigungen/-Pauschalen',
        // },
        // {
        // 	value: 'Wz-Entschädigungen/-Pauschalen',
        // 	title: 'Wz-Entschädigungen/-Pauschalen',
        // },
        // {
        // 	value: 'Verpfl.-Entschädigungen/-Pauschalen',
        // 	title: 'Verpfl.-Entschädigungen/-Pauschalen',
        // },
        { value: 'Diverses', title: 'Diverses' },
        // { value: 'Administration', title: 'Administration' },
        { value: 'Material', title: 'Material' }
        // { value: 'Sammelrechnung', title: 'Sammelrechnung' },
    ],
    ArticleGroups: [
        { value: 'Delta', title: 'DELTA' },
        { value: 'Basic', title: 'BASIC' },
        { value: 'CrewX', title: 'CREWX' },
        { value: 'Steward', title: 'STEWARD' },
        { value: 'Consulting', title: 'CONSULTING' },
        { value: 'Academy', title: 'ACADEMY' }
    ],
    Cantons: [
        { value: '9513', title: 'Canton TI', states: ['Ticino'] },
        {
            value: '9511',
            title: 'Cantons BS/BL/GE',
            states: ['Basel-Stadt', 'Basel-Landschaft', 'Geneva']
        },
        { value: '9510', title: 'Canton ZH', states: ['Zürich', 'Zurich'] },
        { value: '9512', title: 'Canton Ubrige', states: ['Ubrige'] }
    ],
    ThumbnailDimensions: 200,
    /*Cantons: [
        { value: 'ZH', title: 'Canton ZH', state: 'Zürich' },
        { value: 'BS', title: 'Canton BS', state: 'Basel-Stadt' },
        { value: 'Ticino', title: 'Ticino', state: 'Ticino' },
        { value: 'BL', title: 'Canton BL', state: 'Basel-Landschaft' },
        { value: 'GE', title: 'Canton GE', state: 'Geneva' },
        { value: 'übrige', title: 'Ubrige', state: 'Ubrige' },
    ],*/
    MealRegulations: [
        {
            foodItemId: '4811',
            title: 'Independent // Entitled to expenses'
        },
        {
            foodItemId: 'SEL0001',
            title: 'Independent // no entitlement to expenses'
        },
        {
            foodItemId: 'SEL0002',
            title: 'By DELTA // no expense entitlement'
        },
        {
            foodItemId: 'SEL0003',
            title: 'By client // no entitlement to expenses'
        },
        {
            foodItemId: 'SEL0004',
            title: 'Non'
        },
        {
            foodItemId: 'SEL0005',
            title: 'Lunch'
        },
        {
            foodItemId: 'SEL0006',
            title: 'Lunch Package'
        },
        {
            foodItemId: 'SEL0007',
            title: 'Dinner'
        },
        {
            foodItemId: 'SEL0008',
            title: 'Snack'
        },
        {
            foodItemId: 'SEL0009',
            title: 'Lunch / Dinner'
        },
        {
            foodItemId: 'SEL0010',
            title: 'Organized / entitled to expenses'
        }
    ],
    Batches: [
        'None',
        'Main Batch',
        'Vorstaffelung / Pre-Batch',
        'Nachstaffelung / After-Batch',
        'Batch 1',
        'Batch 2',
        'Batch 3',
        'Batch 4',
        'Batch 5',
        'Batch 6',
        'Batch 7',
        'Batch 8',
        'Batch 9',
        'Batch 10',
        'Batch 11',
        'Batch 12',
        'Batch 13',
        'Batch 14',
        'Batch 15',
        'Batch 16',
        'Batch 17',
        'Batch 18',
        'Batch 19',
        'Batch 20',
        'Batch 21',
        'Batch 22',
        'Batch 23',
        'Batch 24',
        'Batch 25',
        'Batch 26',
        'Batch 27',
        'Batch 28',
        'Batch 29',
        'Batch 30',
        'Batch 31',
        'Batch 32',
        'Batch 33',
        'Batch 34',
        'Batch 35',
        'Batch 36',
        'Batch 37',
        'Batch 38',
        'Batch 39',
        'Batch 40',
        'Batch 41',
        'Batch 42',
        'Batch 43',
        'Batch 44',
        'Batch 45',
        'Batch 46',
        'Batch 47',
        'Batch 48',
        'Batch 49',
        'Batch 50',
        'Batch 51',
        'Batch 52',
        'Batch 53',
        'Batch 54',
        'Batch 55',
        'Batch 56',
        'Batch 57',
        'Batch 58',
        'Batch 59',
        'Batch 60',
        'Batch 61',
        'Batch 62',
        'Batch 63',
        'Batch 64',
        'Batch 65',
        'Batch 66',
        'Batch 67',
        'Batch 68',
        'Batch 69',
        'Batch 70',
        'Batch 71',
        'Batch 72',
        'Batch 73',
        'Batch 74',
        'Batch 75',
        'Batch 76',
        'Batch 77',
        'Batch 78',
        'Batch 79',
        'Batch 80',
        'Batch 81',
        'Batch 82',
        'Batch 83',
        'Batch 84',
        'Batch 85',
        'Batch 86',
        'Batch 87',
        'Batch 88',
        'Batch 89',
        'Batch 90',
        'Batch 91',
        'Batch 92',
        'Batch 93',
        'Batch 94',
        'Batch 95',
        'Batch 96',
        'Batch97',
        'Batch 98',
        'Batch 99',
        'Batch 100'
    ],
    WeekDays: [
        { title: 'Sunday', value: 0 },
        { title: 'Monday', value: 1 },
        { title: 'Tuesday', value: 2 },
        { title: 'Wednesday', value: 3 },
        { title: 'Thursday', value: 4 },
        { title: 'Friday', value: 5 },
        { title: 'Saturday', value: 6 }
    ],
    Dates: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31
    ],
    Holidays: ['12-31', '12-25', '12-24', '12-26', '12-01'],
    DressCodes: [
        {
            TenueCode: 'Anzug 10',
            ItemGroup: '1. Abt. Delta AT',
            Description:
                'Suit anthracite, DELTA shirt, DELTA tie, black low shoes, DELTA-PIN'
        },
        {
            TenueCode: 'Anzug 11',
            ItemGroup: '1. Abt. Delta AT',
            Description:
                'neutral, dark suit, neutral shirt, neutral tie, black shoes'
        },
        {
            TenueCode: 'FH 10',
            ItemGroup: '1. Abt. Delta AT',
            Description:
                'Firehouse (black uniform trousers, black T-shirt or turtleneck)'
        },
        {
            TenueCode: 'GA10',
            ItemGroup: '1. Abt. Delta AT1. Abt. Delta AT',
            Description:
                'Civilian clothing adapted to the weather, black shoes, (operational boots are an advantage), note material'
        },
        {
            TenueCode: 'Instr 10',
            ItemGroup: '1. Abt. Delta AT',
            Description: 'Instr. pants, T-shirt, sweater'
        },
        {
            TenueCode: 'Mittel 10',
            ItemGroup: '1. Abt. Delta AT',
            Description:
                'MEDIUM (parka/soft shell jacket, black uniform trousers, polo shirt)'
        },
        {
            TenueCode: 'Norm 10',
            ItemGroup: '1. Abt. Delta AT',
            Description:
                'NORM (overall, b/w T-shirt, parka jacket, combat boots, Béret)'
        },
        {
            TenueCode: 'Norm 10 A',
            ItemGroup: '1. Abt. Delta AT',
            Description:
                'NORM (overall, b/w T-shirt, parka jacket, combat boots, Béret) + ID (accreditation)'
        },
        {
            TenueCode: 'Norm 10 OD',
            ItemGroup: '1. Abt. Delta AT',
            Description:
                'NORM (Overall, b/w T-shirt, parka jacket, combat boots, Béret, rolling cap, helmet, OD vest)'
        },
        {
            TenueCode: 'Norm AT 10',
            ItemGroup: '1. Abt. Delta AT',
            Description:
                'NORM AT (black overall, b/w T-shirt, parka jacket, combat boots, Béret)'
        },
        {
            TenueCode: 'NormAT 1 A',
            ItemGroup: '1. Abt. Delta AT',
            Description:
                'NORM AT (black overall, b/w T-shirt, parka jacket, combat boots) + ID card (accreditation)'
        }
    ],
    Boards: [
        {
            ItemId: '7c8efea4-163f-4ebb-9bc0-24bb4838c3b6',
            Title: 'CrewX',
            Description: 'Manage applications, schedule and hire employees.',
            BoardColor: '#719430'
        },
        {
            ItemId: 'b5403be4-f66f-4736-98f1-505a0cba3682',
            Title: 'Basic',
            Description: 'Manage applications, schedule and hire employees.',
            BoardColor: '#f5a700'
        },
        {
            ItemId: 'c7684ada-fa1f-4e1a-a2d7-ed8bfa53863c',
            Title: 'ServX',
            Description: 'Manage applications, schedule and hire employees.',
            BoardColor: '#00e600'
        },
        {
            ItemId: 'e14997a5-9ada-4d62-b94f-d7a471c24c5b',
            Title: 'Delta',
            Description: 'Manage applications, schedule and hire employees.',
            BoardColor: '#ffed00'
        },
        {
            ItemId: '67ef894a-6c97-4d3e-9610-246b002860be',
            Title: 'DELTA Consulting',
            Description: 'Manage applications, schedule and hire employees.',
            BoardColor: '#ffed00'
        },
        {
            ItemId: '638c87b3-0db2-4e0f-ae69-739e6b9d0671',
            Title: 'DELTA Academy',
            Description: 'Manage applications, schedule and hire employees.',
            BoardColor: '#ffed00'
        }
    ],
    OccupationalProfessions: [
        {
            key: 'Oberstes und oberes Kader',
            value: 'Oberstes und oberes Kader'
        },
        { key: 'Mittleres Kader', value: 'Mittleres Kader' },
        { key: 'Unteres Kader', value: 'Unteres Kader' },
        { key: 'Unterstes Kader', value: 'Unterstes Kader' },
        { key: 'Ohne Kaderfunktion', value: 'Ohne Kaderfunktion' }
    ],
    Datatable: {
        DefaultPageNumber: 0,
        PageSize: 10
    },
    Pagination: {
        PageNumber: 0,
        PageSize: 100
    },
    AssigneePagination: {
        PageNumber: 0,
        PageSize: 10,
        MaxPage: 0
    },
    Entity: {
        ArcLead: 'ArcLead',
        ArcCompany: 'ArcCompany',
        ArcBuyingCenter: 'ArcBuyingCenter',
        ArcBuyingCenterContract: 'ArcBuyingCenterContract',
        AppRole: 'AppRole',
        Connection: 'Connection',
        QualificationMatrix: 'QualificationMatrix',
        OnsiteProductStanding: 'OnsiteProductStanding',
        File: 'File',
        User: 'User',
        Person: 'Person',
        Tag: 'Tag',
        PlatformDictionary: 'PlatformDictionary',
        SpecialAgreementItem: 'SpecialAgreementItem',
        Applicant: 'Applicant',
        DeltaOfferDescriptionTemplate: 'DeltaOfferDescriptionTemplate',
        FormField: 'FormField',
        Validation: 'Validation',
        CountryInfos: 'CountryInfo',
        Board: 'Board',
        ApplicantComment: 'ApplicantComment',
        Assignee: 'Person',
        EmployeeDesignation: 'EmployeeDesignation',
        Job: 'DeltaJob',
        Employee: 'DeltaEmployee',
        DeltaEmployee: 'DeltaEmployee',
        SubscriptionPlan: 'SubscriptionPlan',
        PlanSubscriber: 'PlanSubscriber',
        DeltaCourse: 'DeltaCourse',
        DeltaCourseEnrollment: 'DeltaCourseEnrollment',
        CourseQuizAnswer: 'CourseQuizAnswer',
        CourseQuiz: 'CourseQuiz',
        DeltaClient: 'DeltaClient',
        DeltaOffer: 'DeltaOffer',
        TempProjectInformation: 'TempProjectInformation',
        OfferInformation: 'OfferInformation',
        ProjectModule: 'ProjectModule',
        OfferProduct: 'OfferProduct',
        TempProjectProduct: 'TempProjectProduct',
        TempProjectMaterial: 'TempProjectMaterial',
        DeltaOfferHistory: 'DeltaOfferHistory',
        DeltaEmployeeSchedule: 'DeltaEmployeeSchedule',
        DeltaEmployeeLeaveSchedule: 'DeltaEmployeeLeaveSchedule',
        PlaningGroup: 'PlanningGroup',
        OnsiteOffer: 'OnsiteOffer',
        DeltaWorkPlace: 'DeltaWorkPlace',
        DeltaProject: 'DeltaProject',
        OperationPlace: 'OperationPlace',
        EmSegmentation: 'EmSegmentation',
        HrSegmentation: 'HrSegmentation',
        HolidayInformation: 'HolidayInformation',
        SpecialDayArticle: 'SpecialDayArticle',
        RuleConfig: 'RuleConfig',
        PayrollSetting: 'PayrollSetting',
        ItemMaster: 'ItemMaster',
        ArticleGroup: 'ArticleGroup',
        MaterialPackage: 'MaterialPackage',
        MaterialPackageItem: 'MaterialPackageItem',
        PlanningGroup: 'PlanningGroup',
        ScoringSummary: 'ScoringSummary',
        DeltaEventSchedule: 'DeltaEventSchedule',
        MutationLog: 'MutationLog',
        OnsiteAssignment: 'OnsiteAssignment',
        QualityReportReviewStatus: 'QualityReportReviewStatus',
        QualitySurveyReport: 'QualitySurveyReport',
        DailyProjectControlReport: 'DailyProjectControlReport',
        DailyIncidentReport: 'DailyIncidentReport',
        DeltaComplaint: 'DeltaComplaint',
        DeltaCustomer: 'DeltaCustomer',
        ProjectDailyProgress: 'ProjectDailyProgress',
        EmployeeAggregateInformation: 'EmployeeAggregateInformation',
        ProjectInformation: 'ProjectInformation',
        ClientContactPerson: 'ClientContactPerson',
        ClientOrganization: 'ClientOrganization',
        ClientInformation: 'ClientInformation',
        ProjectProduct: 'ProjectProduct',
        DailyProjectInformation: 'DailyProjectInformation',
        SpecialAgreement: 'SpecialAgreement',
        OfferMaterial: 'OfferMaterial',
        ProjectMaterial: 'ProjectMaterial',
        OfferHistory: 'OfferHistory',
        ArticleMaterial: 'ArticleMaterial',
        WorkableSchedule: 'WorkableSchedule',
        ScheduleEvent: 'ScheduleEvent',
        ProductStanding: 'ProductStanding',
        ProductAssignment: 'ProductAssignment',
        PaymentBasicInformation: 'PaymentBasicInformation',
        PaymentByMonth: 'PaymentByMonth',
        ProductStandingReportInfo: 'ProductStandingReportInfo',
        QualificationReport: 'QualificationReport',
        Announcement: 'Announcement',
        DressCode: 'DressCode',
        EmployeeProfileInfo: 'EmployeeProfileInfo',
        InventoryTransaction: 'InventoryTransaction',
        InventoryTransactionItem: 'InventoryTransactionItem',
        EmployeeHrYearInfo: 'EmployeeHrYearInfo',
    },
    snackBar: {
        DurationError: 2000,
        Duration: 2000,
        VerticalPosition: 'start',
        HorizontalPosition: 'bottom',
        PanelClass: 'snackbar-custom-class'
    },
    Tags: {
        IsALead: 'Is-A-Lead',
        Person: 'Person',
        Admin: 'Is-A-Admin',
        Applicant: 'Applicant',
        SubscriptionPlan: 'SubscriptionPlan',
        CourseQuiz: 'Course-Quiz',
        CourseQuizAnswer: 'CourseQuizAnswer',
        PlanSubscriber: 'PlanSubscriber',
        PlatformDictionary: 'PlatformDictionary',
        DeltaCourseEnrollment: 'DeltaCourseEnrollment',
        PersonForUser: 'Person-For-User',
        ProfileImageOfPerson: 'ProfileImage-Of-Person',
        ProductStanding: 'ProductStanding',
        OnsiteProductStanding: 'OnsiteProductStanding',
        QualificationReport: 'QualificationReport',
        IsAResource: 'Is-A-Resource'
    },
    LanguageKey: {
        English: 'en-US',
        French: 'fr-FR',
        German: 'de-DE'
    },
    Salutation: {
        MR: 'Mr',
        MRS: 'Mrs'
    },
    SpecificFields: {
        ScheduleEvent: [
            'ItemId',
            'ScheduleType',
            'LeaveType',
            'StartDateTime_ZoneSpecific',
            'EndDateTime_ZoneSpecific',
            'StartDateTime',
            'EndDateTime',
            'PersonId',
            'ScheduleTitle',
            'EmployeeUnavailabilityTitle',
            'Note',
            'ProjectNote',
            'EmployeeUnavailabilityNote',
            'AssignmentStatus',
            'AssigneeId',
            'DessCode',
            'DailyProjectId',
            'ProductStandingId',
            'ProductId',
            'ProjectName',
            { Location: AddressInfo },
            'DeltaEmployeeLeaveId',
            'StartTimeInSeconds',
            'EndTimeInSeconds',
            'ArticleName',
            'EmployeeActionStatus',
            'ActionStatus',
            'AcceptedLeaveAmount',
            'Documents',
            'DocumentsExpiryDate',
            'LastActionTakenBypersonId',
            'LastActionTakenById',
            'LastActionTakenBy',
            'EmployeeCategory',
            'PlanningGroupId',
            'PlanningGroup',
            'AssignmentType'
        ],
        Announcement: [
            "ItemId", 'Title', 'AnnouncerName', 'AnnouncerRoles', 'Description', { Projects: DailyProjectInfoPartial }, 'StartDate'
        ],
        DeltaEmployee: [
            'ItemId',
            'PersonId',
            'Sex',
            'Email',
            'DisplayName',
            'PhoneNumber',
            'Designation',
            'PrimaryWorkplace{Address}',
            'ProfileImageId',
            'Street',
            'PostalCode',
            'City',
            'Country',
            'State',
            'BankName',
            'BankAccountOwner',
            'IBAN',
            'CurrentOccupation',
            'EmergencyContact',
            'EmergencyMobileNo',
            'EmergencyContactRelation',
            'EmergencyAddress',
            'EmergencyEmail',
            'Category',
            'JoiningDate',
            'Salutation'
        ]
    },
    AllFieldsOfEntity: {
        Announcement: [
            'ItemId',
            'CreatedBy',
            'AnnouncerName',
            'AnnouncerRoles',
            'Title',
            'Description',
            'Priority',
            'Roles',
            { Projects: DailyProjectInfoPartial },
            'SharedWithPersonIds',
            'StartDate',
            'EndDate',
            {
                Documents: [
                    'FileId',
                    'Title',
                    'DateOfIssue',
                    'ExpiryDate',
                    'Source',
                    'Type',
                    'Url'
                ]
            }
        ],
        Connection: ['ItemId', 'Tags'],
        ScheduleEvent: [
            'ItemId',
            'Tags',
            'AssignmentDate',
            'AssignmentDate_ZoneSpecific',
            'StartDateTime',
            'EndDateTime',
            'StartDateTime_ZoneSpecific',
            'EndDateTime_ZoneSpecific',
            'StartTime',
            'EndTime',
            'StartTimeInSeconds',
            'EndTimeInSeconds',
            'AssignmentDuration',
            'TimeZoneInMinute',
            'OverNightJob',
            'MonthName',
            'Month',
            'Year',
            'TotalHour',
            'ScheduleTitle',
            'Note',
            'ScheduleType',
            'PersonId',
            'EmployeeId',
            'CustomerId',
            'FirstName',
            'LastName',
            'DisplayName',
            'ProfileImageId',
            'EmployeeCategory',
            'DepartmentId',
            'Department',
            'PhoneNumber',
            'MobileNumber',
            'PersonnelNumber',
            'Email',
            'ProjectId',
            'DailyProjectId',
            'ProjectName',
            'AssigneeId',
            'ProductId',
            'ArticleId',
            'ArticleName',
            'ArticleCategory',
            'InvitationDate',
            'AcceptDate',
            'RejectionDate',
            'RejectionReason',
            'ConfirmationDate',
            'Staggering',
            'ArticleDepartment',
            'ArticleDepartmentId',
            'ProjectNote',
            'AssignmentStatus',
            'DessCode',
            'DessDescription',
            'PlanningGroupId',
            'PlanningGroup',
            'ArticleGroupId',
            'ArticleGroup',
            'EmployeeUnavailabilityId',
            'EmployeeUnavailabilityNote',
            'EmployeeUnavailabilityTitle',
            { Location: AddressInfo },
            'LeaveType',
            'WishlistDeadline',
            'Documents',
            'DocumentsExpiryDate',
            'ActionStatus',
            'IsSystemGenerated',
            'RadioApplicable',
            'InternalNote',
            'ActionNote',
            'ProductStandingId',
            'IsReadByEmployee',
            'DeltaEmployeeLeaveId',
            'EmployeeActionStatus',
            'IsLeaveInWeekendOrHoliday',
            'IsReadByEmployeeAfterUpdate',
        ],
        DailyProjectControlReport: [
            'ItemId',
            'LastUpdateDate',
            'ReportDate',
            'TimeZoneInMinute',
            'ProjectId',
            'OperationControllerId',
            'ControlledEmployeeIds',
            { Dress: OfferDressCode },
            'Equipments',
            'Tasks',
            'ImportantInformation',
            'AdditionalInformation',
            'MaKnowOrder',
            'EquipmentCompleted',
            'TenueIsCorrect',
            'FriendlyAppearance',
            'MissionReportClean',
            { QuestionAnswers: ['ItemKey', 'ItemValue'] },
            { Criterias: ['ItemKey', 'ItemValue'] },
            'Status'
        ],
        DailyIncidentReport: [
            'ItemId',
            'ReportDate',
            'Application',
            'ProjectId',
            'TimeZoneInMinute',
            'Service',
            { Dress: OfferDressCode },
            'OperationalVehicle',
            'StartTimeInSeconds',
            'EndTimeInSeconds',
            { Address: AddressInfo },
            {
                Reports: [
                    'ReportDetailId',
                    'ReportName',
                    'Observation',
                    'MeasureTaken',
                    'IncidentTimeInSeconds',
                    'IncidentFileIds',
                    'IncidentDate'
                ]
            }
        ],

        User: [
            'Active',
            'CreateDate',
            'CreatedBy',
            'DisplayName',
            'Email',
            'EmailVarified',
            'Language',
            'LastUpdateDate',
            'LastUpdatedBy',
            'PhoneNumber',
            'Platform',
            'ProfileImageUrl',
            'Roles',
            'TenantId',
            'UserName',
            'FirstName',
            'LastName',
            'UserSignup',
            'ExternalProviderUserId',
            'ProfileImageId',
            'EverLoggedIn',
            'ItemId',
            'Tags',
            'CountryCode',
            'Salutation',
            'TwoFactorEnabled',
            'IsSystemBlocked'
        ],
        Person: [
            'ItemId',
            'CreatedBy',
            'Tags',
            'DateOfBirth',
            'Title',
            'Sex',
            'FirstName',
            'LastName',
            'MiddleName',
            'DisplayName',
            'Salutation',
            'Nationality',
            'PhoneNumber',
            'Designation',
            'Active',
            'Department',
            'ProfileImage',
            'JoiningDate',
            'Email',
            'Roles',
            'ProfileImageId',
            'Location',
            'PersonId'
        ],
        Applicant: [
            'id: ItemId',
            'name: DisplayName',
            'FirstName',
            'LastName',
            'AddressLine1',
            'Salutation',
            'PhoneNumber',
            'Email',
            'CreateDate',
            'DateOfBirth',
            'Hobby',
            'PermitType',
            'PermitExpireDate',
            'Height',
            'Weight',
            'Street',
            'City',
            'PostalCode',
            'Country',
            'Nationality',
            'ProfileImageId',
            'ApplicationDocument',
            'OtherDocuments',
            { Assignee: UserInfo },
            'Priority',
            'InterviewDate',
            'InterviewStartTime',
            'InterviewEndTime',
            'CivilStatus',
            'CivilStatusFrom',
            'NumberOfChildren',
            'NumberOfPersonInHouse',
            'PersonalEducation',
            'PersonalOccupation',
            'CurrentOccupation',
            'TypeOfOccupation',
            'Vehicle',
            'WorkInterest',
            'IncomeExpectation',
            'Miscellaneous',
            'EarningProgram',
            'StreetNumber',
            'ProfileImage',
            'Language',
            'BankName',
            'BankAccountHolderName',
            'IBAN',
            'AHVNumber',
            'LiableWithholdingTax',
            'Confession',
            'HiringStatus',
            'DocumentCheckLists',
            'Attachments',
            { Activities: Activity },
            'IsArchived',
            'BoardId',
            'Tags',
            'KnownLanguages',
            'Skills',
            'Sex',
            'MartialArtsExperience',
            'MartialArtsStyle',
            'ExperienceSecurity',
            'AwardsMartialArts',
            'NativeLanguage',
            'PersonId',
            'TrainingLevel',
            'Availability',
            'AvailabilityShift',
            'Recommended',
            'Hometown',
            'ExperienceInStageSetup',
            'ExperienceInStageDisassembly',
            'BirthPlace',
            'MilitaryGrade',
            'MilitaryFunction',
            'OtherInfos',
            'OtherAreaExpertises',
            'IsMarkedToDelete',
            // 'PersonnelNumber',
            'ShiftStartTimeInSeconds',
            'ShiftEndTimeInSeconds',
            'Remarks',
            'JobPreference',
            'Motivation',
            'RecommendedOtherInfo',
            'IsAhvExistInApplicant',
            'IsEmailExistInApplicant',
            'IsEmailExistInEmployee',
            'IsEmailExistInArchived',
            'AvailabilityShifts'
        ],
        FormField: [
            'ItemId',
            'FormId',
            'Title',
            'FieldKey',
            'FieldType',
            'InputId',
            'IsVisibleToForm',
            'InputElementType',
            'InputElementTypeTitle',
            'InputTypeValue',
            'FieldValue',
            'FieldFor',
            'SortingOrder',
            'Validations',
            { SubFields: SubField },
            'IsFieldValidationDependent',
            'IsBusinessSpecificValidation',
            'IsMappedToDbEntity',
            'RequireType',
            'OptionalStringifylData',
            'DefaultStringifyValue',
            'ValidationStringifyData',
            'IsCustomValidation'
        ],
        Validation: [
            'ItemId',
            'Title',
            'ValidationTypeKey',
            'ValidationType',
            'ValidationValueType',
            'Operation',
            'ValidationMessage',
            'ValidationStringifyValue'
        ],
        Assignee: [
            'UserInfoId: ItemId',
            'Name: DisplayName',
            'Avatar: ProfileImage',
            'Roles',
            'Email',
            'ProfileImageId'
        ],
        EmployeeAsAssignee: [
            'PersonId',
            'EmployeeId: ItemId',
            'Name: DisplayName',
            'Avatar: ProfileImageId',
            'Roles',
            'Email'
        ],
        CountryInfos: ['id: ItemId', 'Name', 'Code'],
        Board: [
            'id: ItemId',
            'Title',
            'Description',
            'BoardColor',
            'FormId',
            { PrimaryAddress: ['Lat', 'Lng'] },
            'IsMarkedToDelete'
        ],
        ApplicantComment: [
            'id: ItemId',
            'ApplicantId',
            'CommentText',
            'CommentTime',
            { CommentedBy: UserInfo },
            'Language',
            'Tags'
        ],
        DeltaOfferDescriptionTemplate: [
            'ItemId',
            'TemplateName',
            'TemplateDescription'
        ],
        ApplicantAsPerson: ['ItemId', 'Tags', 'Roles', 'Department'],
        EmployeeDesignation: ['ItemId', 'BoardId', 'DesignationTitle', 'Tags'],
        Job: [
            'ItemId',
            'JobTitle',
            'JobType',
            'JobDescription',
            'Deadline',
            'JobLocation',
            'Salary',
            'RequiredSkills',
            'FormInformation',
            'CreateDate',
            'ResumeRequired',
            'IsDraft'
        ],
        PlaningGroup: ['ItemId', 'Title'],
        DeltaWorkPlaces: [
            'ItemId',
            'Title',
            'Description',
            'Address',
            'Lng',
            'Lat',
            'WorkplaceName',
            'WorkplaceRecId'
        ],
        MaterialPackage: [
            'ItemId',
            'Title',
            'TotalQuantity',
            'IsActive',
            'Tags',
            'CreateDate'
        ],
        MaterialPackageItem: [
            'ItemId',
            'MaterialTitle',
            'MaterialPackageId',
            'Quantity',
            'MaterialId',
            'Tags',
            'CreateDate'
        ],
        OnsiteOffer: [
            'ItemId',
            'CreateDate',
            'Tags',
            'ProjectId',
            'InvoiceFileId',
            'AdministrativeChargeAmount',
            {
                OfferArticleInfos: [
                    { CantonDetail: OfferArticleDetail },
                    'ArticleDate',
                    'ArticleGroupId',
                    'ArticleGroup',
                    'StartTime',
                    'EndTime',
                    'WorkingHour',
                    'OverNightJob',
                    'FoodApplicable',
                    'RadioApplicable',
                    { FoodItem: OfferArticleDetailOnsiteOffer },
                    { RadioCost: OfferArticleDetailOnsiteOffer },
                    'Distance',
                    { DistanceCost: OfferArticleDetailOnsiteOffer },
                    { TransportationCosts: OfferArticleDetailOnsiteOffer },
                    {
                        OfferArticles: [
                            'OfferArticleId',
                            { Dress: OfferDressCode },
                            'InternalNote',
                            'CustomerNote',
                            { OfferArticle: OfferArticleDetailOnsiteOffer },
                            { Transportation: OfferItemRequestInfo },
                            { Transportations: OfferItemRequestInfo },
                            'RadioApplicable'
                        ]
                    },
                    { ProductArticles: CustomOfferItem },
                    { SurchargeCosts: OfferArticleDetailOnsiteOffer },
                    'InternalNote',
                    'CustomerNote',
                    'RecurrentDate',
                    'SubTotal',
                    'SubTotalOfDiscount',
                    'SubTotalOfKBaseOneAmount',
                    'SubTotalOfKBaseTwoAmount',
                    'Staggering',
                    'OfferArticleInfoId'
                ]
            },
            'ClientId',
            'TotalAmount',
            'SubTotal',
            'TotalVat',
            'TotalRevenuePercentage',
            'TotalRevenueAmount',
            'TotalKBaseTwoAmount'
        ],
        DeltaOffer: [
            'ItemId',
            'OfferTitle',
            'InvoiceFileId',
            'Remark',
            'ContactPersonId',
            {
                Client: [
                    'EntityId',
                    'Title',
                    'Image',
                    'Description',
                    'BranchId'
                ]
            },
            'OfferStatus',
            'Canton',
            'ContactInfo',
            {
                PlanningGroup: [
                    'EntityId',
                    'Title',
                    'Description',
                    'Code',
                    'Image'
                ]
            },
            'ContactMobileNumber',
            'OfferSentDate',
            'OfferAmount',
            'StartDate',
            'EndDate',
            {
                OfferCreatededBy: ['Roles', 'PersonId', 'Name']
            },
            {
                OfferManager: ['Roles', 'PersonId', 'Name']
            },
            {
                OfferPlanner: ['Roles', 'PersonId', 'Name']
            },

            'ParkingRegulation',
            // 'OfferArticle{OfferArticleInfos{ArticleGroup,ArticleDate,StartTime,EndTime,OverNightJob,OfferArticles{ArticleId,ArticleDescription,ArticleCategory,ArticleQuantity}}}',
            // eslint-disable-next-line max-len
            'OfferArticle {SubTotal,TotalVat,TotalAmount,OfferArticleInfos{ArticleGroup,ArticleDate,StartTime,EndTime,WorkingHour,OverNightJob,SurchargeCosts{ArticleId,ArticleDescription,ArticleCategory,ArticleQuantity,ArticleExternalUnitPrice,ArticleExternalFinalAmount},TransportationCosts{ArticleId,ArticleDescription,ArticleCategory,ArticleQuantity,ArticleExternalUnitPrice,ArticleExternalFinalAmount},RadioCost{ArticleId,ArticleDescription,ArticleCategory,ArticleQuantity,ArticleExternalUnitPrice,ArticleExternalFinalAmount},DistanceCost{ArticleId,ArticleDescription,ArticleCategory,ArticleQuantity,ArticleExternalUnitPrice,ArticleExternalFinalAmount},FoodItem{ArticleId,ArticleDescription,ArticleCategory,ArticleQuantity,ArticleExternalUnitPrice,ArticleExternalFinalAmount},OfferArticles{Dress{TenueCode},InternalNote,CustomerNote,RadioApplicable,Transportation{ItemName,Quantity},Transportations{ItemId,ItemName,Quantity},OfferArticle {ArticleId,ArticleDescription,ArticleCategory,ArticleQuantity,ArticleExternalUnitPrice,ArticleExternalFinalAmount}},ProductArticles{Dress{TenueCode},InternalNote,CustomerNote,RadioApplicable,Transportation{ItemName,Quantity},OfferArticle {ArticleId,ArticleDescription,ArticleCategory,ArticleQuantity,ArticleExternalUnitPrice,ArticleExternalFinalAmount}}}}',
            {
                BillingAddress: BillingAddress
            },
            {
                Venue: ['Address']
            },
            {
                MeetingPoint: ['Address']
            },
            {
                ParkingLocation: ['Address']
            },
            {
                MainEmploymentLocation: ['Address']
            }
        ],
        DeltaOfferHistory: [
            'ItemId',
            'OfferTitle',
            'Remark',
            {
                Client: [
                    'EntityId',
                    'Title',
                    'Image',
                    'Description',
                    'BranchId'
                ]
            },
            'OfferStatus',
            'Canton',
            'ContactInfo',
            {
                PlanningGroup: [
                    'EntityId',
                    'Title',
                    'Description',
                    'Code',
                    'Image'
                ]
            },
            'ContactMobileNumber',
            'OfferSentDate',
            'OfferAmount',
            'StartDate',
            'EndDate',
            {
                OfferCreatededBy: ['Roles', 'PersonId', 'Name']
            },
            {
                OfferManager: ['Roles', 'PersonId', 'Name']
            },
            {
                OfferPlanner: ['Roles', 'PersonId', 'Name']
            },

            'ParkingRegulation',
            // 'OfferArticle{OfferArticleInfos{ArticleGroup,ArticleDate,StartTime,EndTime,OverNightJob,OfferArticles{ArticleId,ArticleDescription,ArticleCategory,ArticleQuantity}}}',
            // eslint-disable-next-line max-len
            'OfferArticle {SubTotal,TotalVat,TotalAmount,OfferArticleInfos{ArticleGroup,ArticleDate,StartTime,EndTime,WorkingHour,OverNightJob,SurchargeCosts{ArticleId,ArticleDescription,ArticleCategory,ArticleQuantity,ArticleExternalUnitPrice,ArticleExternalFinalAmount},TransportationCosts{ArticleId,ArticleDescription,ArticleCategory,ArticleQuantity,ArticleExternalUnitPrice,ArticleExternalFinalAmount},RadioCost{ArticleId,ArticleDescription,ArticleCategory,ArticleQuantity,ArticleExternalUnitPrice,ArticleExternalFinalAmount},DistanceCost{ArticleId,ArticleDescription,ArticleCategory,ArticleQuantity,ArticleExternalUnitPrice,ArticleExternalFinalAmount},FoodItem{ArticleId,ArticleDescription,ArticleCategory,ArticleQuantity,ArticleExternalUnitPrice,ArticleExternalFinalAmount},OfferArticles{Dress{TenueCode},InternalNote,CustomerNote,RadioApplicable,Transportation{ItemName,Quantity},Transportations{ItemId,ItemName,Quantity},OfferArticle {ArticleId,ArticleDescription,ArticleCategory,ArticleQuantity,ArticleExternalUnitPrice,ArticleExternalFinalAmount}},ProductArticles{Dress{TenueCode},InternalNote,CustomerNote,RadioApplicable,Transportation{ItemName,Quantity},OfferArticle {ArticleId,ArticleDescription,ArticleCategory,ArticleQuantity,ArticleExternalUnitPrice,ArticleExternalFinalAmount}}}}',
            {
                BillingAddress: ['Address']
            },
            {
                Venue: ['Address']
            },
            {
                MeetingPoint: ['Address']
            },
            {
                ParkingLocation: ['Address']
            },
            {
                MainEmploymentLocation: ['Address']
            }
        ],
        DeltaProjectScrumboard: [
            'id: ItemId',
            'name: Title',
            'ContactInfo',
            'ContactMobileNumber',
            'Remark',
            { Client: DeltaProjectClient },
            { PlanningGroup: DeltaCommonInfo },
            { Venue: AddressInfo },
            { BillingAddress: BillingAddress },
            { OptionalAddress: BillingAddress },
            { MeetingPoint: AddressInfo },
            { ParkingLocation: AddressInfo },
            { MainEmploymentLocation: AddressInfo },
            'MainEmploymentLocationId',
            'ProjectStatus',
            'StartDate',
            'EndDate',
            { Planner: DeltaEmployeeInfo },
            { ProjectManager: DeltaEmployeeInfo },
            { ProjectCreatedBy: DeltaEmployeeInfo },
            'IsProjectCritical',
            'ParkingRegulation',
            { OfferArticle: OfferArticle }
        ],
        DeltaProject: [
            'ItemId',
            { Client: DeltaProjectClient },
            { BillingAddress: AddressInfo },
            { OptionalAddress: AddressInfo },
            { PlanningGroup: DeltaCommonInfo },
            'Title',
            { Venue: AddressInfo },
            'Canton',
            'ContactInfo',
            'ContactMobileNumber',
            'ContactMobileCountryCode',
            'ContactPersonId',
            { MeetingPoint: AddressInfo },
            'ParkingRegulation',
            { ParkingLocation: AddressInfo },
            { MainEmploymentLocation: AddressInfo },
            'OfferId',
            { OfferArticle: OfferArticle },
            'ProjectStatus',
            'StartDate',
            'EndDate',
            { Planner: DeltaEmployeeInfo },
            'IsProjectCritical',
            { Assignees: ProjectAssignee },
            { PlanningInfos: ProjectPlanningInfo },
            { ProjectCreatedBy: DeltaEmployeeInfo },
            { ProjectManager: DeltaEmployeeInfo },
            { MetarialInfos: ProjectMaterialInfo },
            { VehicleInfos: ProjectVehicleInfo },
            { VehicleEmployees: projectVehicleEmployees },

            // 'DocumentIdList',
            // 'MailDocumentIdList',
            // { OfferArticleInfoStatus: ProjectOfferArticleInfoStatus },
            'DocumentIdList',
            'MailDocumentIdList',
            { OfferArticleInfoStatus: ProjectOfferArticleInfoStatus }
        ],
        OnsiteAssignments: [
            'ItemId',
            'EmployeeId',
            'EmployeeCategory',
            'ProjectId',
            'AssigneeId',
            'AssignmentDate',
            'StartDateTime',
            'EndDateTime',
            'StartTime',
            'EndTime',
            'StartTimeInSeconds',
            'EndTimeInSeconds',
            'ArticleGroup',
            'ArticleGroupId',
            'ArticleCategory',
            'ArticleDescription',
            'OfferArticleInfoId',
            'ArticleId',
            'BoardingPlace',
            'BoardingPlaceId',
            'DepartureTime',
            'DepartureTimeInSeconds',
            'Staggering',
            'Distance',
            'TotalHour',
            'RadioApplicable',
            'CompetenceSurcharges',
            'FoodApplicable',
            'FoodItemId',
            'FoodItemTitle',
            'LastUpdateDate',
            'LastUpdatedBy',
            { Dress: OfferDressCode },
            { ArticleSpecificDesignationCost: OfferArticleDetail },
            { PayrollWorkAdjustments: payrollWorkAdjustmentsDetails },
            { PayrollPerfornamceAdjustments: payrollPerfornamceAdjustments },
            { OnsiteRoleInformations: OnsiteRoleInformations }
        ],
        QualityReportReviewStatuss: [
            'ItemId',
            'Score',
            'LastReviewDate',
            'NextReviewDate',
            'LatestReviewId',
            'ReviewIndex',
            { Employee: QualityEmployee },
            { ReviewedBy: QualityEmployee }
        ],
        QualitySurveyReports: [
            'ItemId',
            'CreateDate',
            'EmployeeId',
            'GeneralRemark',
            'EmployeeFeedback',
            'HrComment',
            'ReviewedAsLeader',
            { QuestionAnswers: QuestionAnswers },
            'ProjectName',
            'ProjectDate',
            { Venue: AddressInfo },
            'ArticleId',
            'ArticleName',
            'StartDateTime',
            'EndDateTime',
            'StartDateTime_ZoneSpecific',
            'EndDateTime_ZoneSpecific',
            'Status',
            'ReviewedOn',
            'AverageScore',
            'ProfileImageId',
            'EmployeeName',
            'DailyProjectId'
        ],
        DeltaProject_ForEmployee: [
            'ItemId',
            // 	{ Client: DeltaCommonInfo },
            // { BillingAddress: AddressInfo },
            // { OptionalAddress: AddressInfo },
            // { PlanningGroup: DeltaCommonInfo },
            { OfferArticle: OfferArticle_ForEmployee },
            'Title',
            { Venue: AddressInfo },
            'Canton',
            'ContactInfo',
            'ContactMobileNumber',
            'ContactMobileCountryCode',
            // { MeetingPoint: AddressInfo },
            // 'ParkingRegulation',
            // { ParkingLocation: AddressInfo },
            // { MainEmploymentLocation: AddressInfo },
            // 'OfferId',
            // 'ProjectStatus',
            'StartDate',
            'EndDate',
            // { Planner: DeltaEmployeeInfo },
            // 'IsProjectCritical',
            { Assignees: ProjectAssignee },
            { VehicleInfos: ProjectVehicleInfo },
            { VehicleEmployees: projectVehicleEmployees }
        ],
        ArcBuyingCenter: [
            'ItemId',
            'OrganizationId',
            'MetaTags',
            'Name',
            'Industry',
            'Description',
            { Connection },
            { DefaultCurrency },
            { Documents },
            'ParentId'
        ],
        ArcBuyingCenterContract: [
            'ItemId',
            'Year',
            'Project',
            'Status',
            'Forecast',
            'Invoiced',
            'Earned'
        ],
        DeltaClient: [
            'ItemId',
            'Name',
            'BusinessType',
            'Description',
            'LogoId',
            { MotherAddress: AddressInfo },
            'IsSimilarAsMotherAddress',
            { ContactInformation: ContactInformation },
            { Branches: DeltaClientBranchInfo },
            'IsDraft'
        ],
        DeltaEmployeeSchedule: [
            'ItemId',
            'StartDateTime',
            'EndDateTime',
            'TimeZoneInMinute',
            'EmployeeId',
            'Note',
            'Title',
            'ScheduleType',
            'LeaveType',
            'IsSystemGenerated',
            'DocumentsExpiryDate',
            'Documents',
            'ActionDate',
            'ActionTakenBy',
            'ActionStatus',
            'SchedulePeriod',
            'AssignmentDate'
        ],
        DeltaEmployeeLeaveSchedule: [
            'ItemId',
            'StartDateTime',
            'EndDateTime',
            'TimeZoneInMinute',
            'EmployeeId',
            'Note',
            'Title',
            'ScheduleType',
            'LeaveType',
            'IsSystemGenerated',
            'DocumentsExpiryDate',
            'ActionDate',
            'ActionTakenBy',
            'ActionStatus',
            'LastActionTakenBypersonId',
            'LastActionTakenById',
            'LastActionTakenBy',
            'EmployeeCategory',
        ],
        ItemMaster: [
            'ItemId',
            'Description',
            'ItemGroup',
            'ArticleId',
            'ArticleCategory',
            'InternalApproach',
            'ExternalApproach',
            'CalculationType',
            'Code',
            'Unit',
            'DepartmentId',
            'Specification',
            'Values',
            'ValuesFor',
            'SurchargeType',
            'CorrespondingArticles',
            'AddKbaseCalculation',
            'DLVClients {ClientId,ExternalPrice,ExternalPriceDiscountPercentage}',
            'EmSegmentations',
            'HrSegmentations',
            {
                CantonSpecificPrices: [
                    'Canton',
                    'InternalApproach',
                    'ExternalApproach'
                ]
            },
            'SundaySurChargeStartTimeInSeconds',
            'SundaySurChargeEndTimeInSeconds',
            'NightSurChargeEndTimeInSeconds',
            'NightSurChargeStartTimeInSeconds',
            'NightSurChargeId',
            'SundaySurChargeId',
            'IncomeAccountGroup',
            'ExpenseAccountGroup',
            'DiscountAccountGroup',
            'KeyFigure',
            'Vat',
            'SortingOption',
            'FA_EZ',
            'GAV',
            'SalaryTypeForYounger20',
            'SalaryTypeForElder21',
            'CreateDate',
            'LastUpdateDate',
            'SurChargeId',
            { CorrespondingItems: ['ItemKey', 'ItemValue'] },
            'Department',
            'ItemGroupId',
            'PlanningGroupId',
            'PlanningGroup',
            'SaturdaySurChargeEndTimeInSeconds',
            'SaturdaySurChargeStartTimeInSeconds',
            'SaturdaySurChargeId',
            'MinimumAmount',
            'MaximumAmount'
        ],
        PayrollSetting: [
            'ItemId',
            'CreateDate',
            'Tags',
            'Title',
            'Description',
            'Unit',
            'ArticleId',
            'RelatedKeys',
            'RelatedField',
            'ItemMasterId',
            'SettingEmployeeCategories',
            {
                SettingValues: [
                    'ValueId',
                    'Key',
                    'CompositeKey',
                    'Value',
                    'ValueType'
                ]
            },
            'IsBaseSetting',
            'IsSurcharge',
            'CalculationType',
            'Specification',
            'IsSingleSettingValue',
            'Cantons',
            'IsFullTime',
            'MonthlyHourRetention',
            'HourRetentionLimit',
            'MonthlyHourTarget',
            'DailyHourTarget',
            'MonthlyProjectedSalary'
        ],
        ArticleGroup: ['ItemId', 'Title', 'Description', 'Tags'],
        PlanningGroup: ['ItemId', 'Title', 'Description'],
        Employee: [
            'ItemId',
            'PersonId',
            'DeltaSpecificRoles',
            'CreateDate',
            'DisplayName',
            'DateOfBirth',
            'Designation',
            'MartialArtsExperience',
            'Sex',
            'ExperienceSecurity',
            'ProfileImageId',
            'DobMonth',
            'DobDay'
        ],
        DeltaCustomer: [
            'ItemId',
            'CreateDate',
            'Name',
            'Description',
            'BusinessType',
            'LogoId',
            'ParentId',
            'BuyingCenterId',
            'EmployeeId',
            'CustomerType',
            'Emails',
            'SortableFieldValue',
            'CompositeTitle',
            'SimplifiedLogoId',
            {
                Addresses: [
                    'Address',
                    'Country',
                    'State',
                    'City',
                    'House_Number',
                    'Street',
                    'Street_Number',
                    'Postal_Code',
                    'Country_Code',
                    'MapUrl',
                    'Type',
                    'Lat',
                    'Lng',
                    'Description'
                ]
            },
            { Contacts: ContactInformationDetail }
        ],
        OperationPlace: ['ItemId', 'Title', 'Description', 'Code'],
        EmSegmentation: ['ItemId', 'Title', 'Description', 'Code', 'Remark'],
        HrSegmentation: ['ItemId', 'Title', 'Description', 'Code', 'Remark'],
        HolidayInformation: [
            'ItemId',
            'CreateDate',
            'Tags',
            'Title',
            'Description',
            'HolidayDate',
            'StartTimeInSeconds',
            'EndTimeInSeconds',
            'HolidayStartDateTime',
            'HolidayEndDateTime',
            'HolidayYear',
            'HolidayMonth',
            'HolidayDay',
            'IsActive',
            'Cantons'
        ],
        SpecialDayArticle: [
            'ItemId',
            'CreateDate',
            'Tags',
            'Article',
            'ArticleId',
            'SurchargeDate',
            'StartTimeInSeconds',
            'EndTimeInSeconds',
            'SurchargeEndDateTime',
            'SurchargeStartDateTime',
            'SurchargeYear',
            'SurchargeMonth',
            'SurchargeDay',
            'IsActive'
        ],
        RuleConfig: [
            'ItemId',
            'CreateDate',
            'Tags',
            'RuleKey',
            'RuleValueType',
            'RuleNumberValue',
            'RuleTextValue',
            'RuleBooleanValue',
            'RuleDateValue',
            'IsActive'
        ],
        DeltaEmployee: [
            'ApplicationDate',
            'InterviewDate',
            'AGExpiryDate',
            'IdExpiryDate',
            'ItemId',
            'CreatedBy',
            'Tags',
            'DateOfBirth',
            'Title',
            'Sex',
            'FirstName',
            'LastName',
            'MiddleName',
            'DisplayName',
            'Salutation',
            'Nationality',
            'PhoneNumber',
            'Designation',
            'Active',
            'Department',
            'JoiningDate',
            'Email',
            'Roles',
            'ProfileImageId',
            'ProfileImage',
            'Country',
            'CreateDate',
            'MartialArtsExperience',
            'ExperienceSecurity',
            'DobMonth',
            'DobDay',
            'BankName',
            'IBAN',
            'AHVNumber',
            'NumberOfChildren',
            'NumberOfPersonInHouse',
            'Miscellaneous',
            'City',
            'State',
            'MartialArtsStyle',
            'AwardsMartialArts',
            'Skills',
            'ApplicantId',
            'AddressLine1',
            'Language',
            'PersonId',
            'KnownLanguages',
            'NativeLanguage',
            'BusinessTelephone',
            'BusinessTelephoneDirect',
            'ProfessionalSkills',
            'CompanyName',
            'Street',
            'StreetNumber',
            'PostalBox',
            'PostalCode',
            'MobilePhoneNumber',
            'OccupationalPossition',
            { EmSegmentations: DeltaCommonInfo },
            { OperationPlaces: CustomKeyValue },
            'LocationCoordinates',
            'DeltaSpecificRoles',
            'PersonnelNumber',
            'PlanningGroupId',
            'RegisteredOn',
            { RegisteredBy: UserInfo },
            'ProbationEndDate',
            'TerminationDate',
            'NoticeDate',
            'ReasonForNotice',
            'LeavingDate',
            'YearlyHoliday',
            'DepositFee',
            { HrSegmentations: DeltaCommonInfo },
            'EmergencyContact',
            'EmergencyContactRelation',
            'EmergencyMobileNo',
            'EmergencyAddress',
            { InterviewLeader: UserInfo },
            'PrimaryWorkplaceId',
            { PrimaryWorkplace: AddressInfo },
            'SecondaryWorkplaceId',
            { SecondaryWorkplace: AddressInfo },
            'Category',
            'WCHExpiryDate',
            'LIExpiryDate',
            'SHExpiryDate',
            'BLExpiryDate',
            'TIExpiryDate',
            'LastUpdateDate',
            'LastUpdatedBy',
            'PR24ExpiryDate',
            'PR24LIExpiryDate',
            'GunExpiryDate',
            'CPRExpiryDate',
            'IdCardExpiryDate',
            'ZEKExpiryDate',
            'LivingPermitExpiryDate',
            'CrossBorderCommuterCardExpiryDate',
            'LivingPermitCategory',
            'LiableWithholdingTax',
            'Hometown',
            'BirthPlace',
            { ChildInfos: DeltaEmployeeChildren },
            'CivilStatus',
            { EmployeeSchedules: EmployeeSchedule },
            { Unavailabilities: DateTimeRange },
            'OtherDocuments',
            'Attachments',
            'ApplicationDocument',
            'MarriedSince',
            'DepotReceivedOn',
            'FirstEmploymentDate',
            'PlannedHours',
            'EmergencyEmail',
            'DepotReturnedOn',
            'TerminationBy',
            'PersonalEducation',
            'CurrentOccupation',
            'ExperienceInStageSetup',
            'ExperienceInStageDisassembly',
            'ExperiencePromotion',
            'ExperienceHosting',
            'MilitaryGrade',
            'MilitaryFunction',
            'Hobby',
            'Height',
            'Weight',
            'TaxLiabilityTariff'
        ],
        SubscriptionPlan: [
            'Name',
            'ItemId',
            'Price',
            'CreateDate',
            'PriceScope',
            'Logo',
            'IsDisplay',
            'LogoType',
            'IsExistKnowledgeBase',
            'IsDefaultFeature',
            'DiscountDeltaAcademy',
            'DiscountStefan',
            'DeltaContact',
            'Other',
            'Tags',
            'Features',
            'ApplicableFor'
        ],
        PlanSubscriber: [
            'PlanId',
            'PersonId',
            'UserId',
            'SubscriptionDate',
            'SubscriptionStatus',
            'SubscriptionDurationInDays',
            'Tags'
        ],
        PlatformDictionary: ['ItemId', 'Key', 'Value', 'Tags'],
        DeltaCourse: [
            'ItemId',
            'CreateDate',
            'Tags',
            'CourseCover',
            'CourseName',
            'Description',
            'StartDate',
            'EndDate',
            'StartTime',
            'EndTime',
            'Category',
            'Languages',
            'IsOffline',
            'Location',
            'Countries',
            'Regions',
            'Booklist',
            { ArticleLinks: ArticleMeta },
            'Resources',
            'Certificates',
            'IsAgeRestricted',
            'MinAgeRequired',
            'CriteriaDescription',
            'IsDocRequired',
            'DocList',
            'Price',
            'DiscountPercenatge',
            'IsDraft',
            'PublishedDate',
            'NumberOfEnrolledUsers',
            'NumberOfCourseCompletedUsers',
            'IsInternal',
            'IsCourseFree',
            'HrSegmentations',
            'EmSegmentations',
            'RequiredHrSegmentations',
            'RequiredEmSegmentations'
        ],
        DeltaCourseEnrollment: [
            'ItemId',
            'Tags',
            'CreateDate',
            'CourseId',
            'PersonId',
            'AttendeeType',
            'IsAttendee',
            'EnrollmentStatus',
            'EnrollDate',
            { Certificates: DeltaCertificateDetail },
            'PaidAmount',
            'DueAmount',
            'DiscountAvailed',
            'PaymentStatus',
            'Articles',
            'CourseFinalMark',
            'CourseAttendance',
            'IsResultPublished',
            'CourseName',
            'PersonName',
            'ReferenceCourseId',
            'Attachments'
        ],
        CourseQuizAnswer: [
            'ItemId',
            'CreateDate',
            'QuizId',
            'Title',
            'ResultPercentage',
            'IsResultPublished',
            'IsAnswerViwed'
        ],
        CourseQuiz: [
            'ItemId',
            'Title',
            'Description',
            'IsDraft',
            'CourseId',
            'MaxAttempt',
            'ReferenceQuizId',
            'CreateDate',
            `Sections {
				Title
				Description
				Questions {
					QuestionId
					Question
					QuestionType
					Mark
					Options {
						OptionKey
						Option
					}
					QuestionMedia {
						MediaId
						MediaUrl
						MediaType
					}
				}
			}`,
            `CorrectAnswerSections {
				QuestionId
				Options {
					OptionKey
					IsCorrect
				}
			}`
        ],
        ScoringSummary: [
            'ItemId',
            'CommandId',
            'TargetId',
            'Order',
            `IndividualScores {
				ScoreKey,
				ScoreValue
			}`,
            'Tags'
        ],
        DeltaEventSchedule: [
            'ItemId',
            'CreateDate',
            'Tags',
            'StartDateTime',
            'EndDateTime',
            'ScheduleTitle',
            'Note',
            'ScheduleType',
            'EntityId',
            'EntityName',
            'FirstName',
            'LastName',
            'DisplayName',
            'ProfileImageId',
            'EmployeeCategory',
            'PhoneNumber',
            'MobileNumber',
            'ProjectId',
            'ProjectName',
            'ProjectStartDate',
            'ProjectEndDate',
            'AssigneeId',
            'OfferArticleInfoId',
            'OfferArticleId',
            'ArticleId',
            'ArticleName',
            'ArticleCategory',
            'ItemGroup',
            'Depertment',
            'DepertmentId',
            'ProjectNote',
            'AssignmentStatus',
            'Staggering',
            'PlanningGroupId',
            'PlanningGroup',
            'EmployeeUnavailabilityId',
            'EmployeeUnavailabilityNote',
            'EmployeeUnavailabilityTitle',
            { Location: AddressInfo },
            'TimeZoneInMinute'
        ],
        MutationLog: [
            'ItemId',
            'CreateDate',
            'Tags',
            'FieldName',
            'FieldAlias',
            'MutatedOn',
            'MutatedBy',
            'MutationCounter',
            'EntityId',
            'CollectionName',
            'PreviousValue',
            'CurrentValue',
            'ValueType'
        ],
        ArcCompany: [
            'ItemId',
            'Language',
            'CreatedBy',
            'Name',
            'ShortName',
            'Type',
            'CompanyNr',
            { Addresses },
            { PhoneNumbers },
            { Emails },
            'TotalEmployees',
            'LogoId',
            'Industry',
            'Tags',
            'IsEnableListCampaign',
            'DigitalSignageApiKey',
            'MetaTags'
        ],
        ArcLead: [
            'ItemId',
            'CreatedBy',
            'Tags',
            { Addresses },
            'DataStatus',
            'DateOfBirth',
            'DisplayName',
            { Educations },
            { Emails },
            { Employments },
            { FamilyMembers },
            'FirstName',
            'FullName',
            { Identifications },
            'IsMarkedToDelete',
            'LastName',
            'Language',
            'MaritalStatus',
            'MarriedSince',
            'MiddleName',
            'MonthOfBirth',
            { Nationality },
            { PhoneNumbers },
            { ProfileImage: IdentityImages },
            'Title',
            'Salutation',
            'Sex',
            'ProposedUserId',
            'OrganizationId',
            'CompanyId',
            'IsDoubleOptIn',
            'IsCampaignSubscribed',
            'JoinedForm',
            'LeadType',
            'MetaTags',
            { OtherDocuments }
        ],
        ArcLeadForSearch: [
            'ItemId',
            'FirstName',
            'LastName',
            'DisplayName',
            'Sex',
            'DateOfBirth',
            { Emails },
            { PhoneNumbers },
            { ProfileImage: IdentityImages }
        ],
        DeltaComplaint: [
            'ItemId',
            'CreateDate',
            'Tags',
            'Title',
            'Description',
            { ComplainedBy: DeltaEmployeeInfo },
            'ComplainOnEmployeeId'
        ],
        ProjectDailyProgress: [
            'ItemId',
            'ProjectId',
            'AssignmentDateKey',
            'AssignmentDate',
            'OnsiteUpdatedOn',
            'OnsiteUpdatedBy',
            'OnsiteStatus'
        ],
        EmployeeAggregateInformation: [
            'ItemId',
            'CreateDate',
            'Tags',
            'EmployeeId',
            'Year',
            'LeaveLimit',
            'LeaveTaken',
            'WorkLimit',
            'WorkDuration'
        ],
        OfferHistory: [
            'ItemId',
            'EntityId',
            { BillingAddress: BillingAddress },
            {
                BillingContact: [
                    'ContactInfoId',
                    'PersonId',
                    'Name',
                    'Email',
                    'MobileNumber',
                    'MobileCountryCode'
                ]
            },
            {
                OptionalContact: [
                    'ContactInfoId',
                    'PersonId',
                    'Name',
                    'Email',
                    'MobileNumber',
                    'MobileCountryCode'
                ]
            },
            { OptionalAddress: BillingAddress },
            { Venue: BillingAddress },
            { MeetingPoint: BillingAddress },
            'ValidityDate',
            'Title',
            'ProjectCode',
            'ParkingRegulation',
            { ParkingLocation: BillingAddress },
            'MainEmploymentLocationId',
            { MainEmploymentLocation: BillingAddress },
            'Status',
            'Remark',
            'OfferId',
            'Comment',
            {
                Terms: [
                    'ItemKey',
                    'Title',
                    `MultipleValues { ItemKey ItemValue IsSelected} `,
                    'SingleValue',
                    'Remark'
                ]
            },
            'IsArchived',
            'RejectionReason',
            'InvoiceFileId',
            'AdministrativeChargePercentage',
            'AdministrativeChargeAmount',
            'TotalVat',
            'Vat',
            'TotalAmount',
            'DiscountAmount',
            'TotalRevenuePercentage',
            { FoodSurcharges: ['ItemKey', 'ItemValue'] },
            'TotalKBaseTwoAmount',
            'TotalRevenueAmount',
            'VatNumber',
            'CantonSurchargeId',
            'CantonSurcharge',
            'TemplateId',
            'Template',
            'StartDateTime',
            'EndDateTime',
            'TotalSurchargeAmountExternal',
            'CreateDate',
            'TemplateDescription',
            'ProjectContactPersonName',
            'ProjectContactPhoneNumber',
            'Tags',
            'ModuleKey',
            'ModuleName',
            'SubTotalAmount',
            'RequiredEmSegmentations',
            'RequiredHrSegmentations',
            'AchievableEmSegmentations',
            'AchievableHrSegmentations',
            'RequiredDocuments',
            'AcademyTrainingFee',
            'HasAllowance',
            'AllowanceAmount',
            'EligibilityDescription',
            'IsPublic',
            'MaterialPackages',
            {
                Manager: [
                    'UserInfoId',
                    'PersonId',
                    'EmployeeId',
                    'Name',
                    'Avatar',
                    'Roles'
                ]
            },
            {
                Planner: [
                    'UserInfoId',
                    'PersonId',
                    'EmployeeId',
                    'Name',
                    'Avatar',
                    'Roles'
                ]
            },
            {
                OfferCreatededBy: [
                    'UserInfoId',
                    'PersonId',
                    'EmployeeId',
                    'Name',
                    'Avatar',
                    'Roles'
                ]
            },
            {
                Client: [
                    'ClientId',
                    'ParentId',
                    'Description',
                    'OrganizationId',
                    'OrganizationName',
                    'EntityId',
                    'Title',
                    'Image',
                    'DisplayTitle'
                ]
            },
            {
                OptionalClient: [
                    'ClientId',
                    'ParentId',
                    'Description',
                    'EntityId',
                    'OrganizationId',
                    'OrganizationName',
                    'Title',
                    'Image',
                    'DisplayTitle'
                ]
            },
            {
                PlanningGroup: [
                    'Title',
                    'EntityId',
                    'Description',
                    'Code',
                    'Image'
                ]
            },
            {
                Products: [
                    'EntityId',
                    'ProjectId',
                    'AssignmentDate',
                    'StartDateTime',
                    'EndDateTime',
                    'StartTime',
                    'EndTime',
                    'StartTimeInSeconds',
                    'EndTimeInSeconds',
                    'WorkDescription',
                    'OverNightJob',
                    'DepartmentId',
                    'Department',
                    { Dress: OfferDressCode },
                    {
                        SurchargeInfos: [
                            'ArticleId',
                            'ArticleDescription',
                            'SurchargeType'
                        ]
                    },
                    'Distance',
                    'FoodApplicable',
                    'RadioApplicable',
                    'ItemMasterId',
                    'Specification',
                    'ArticleCategory',
                    'ArticleDescription',
                    'ArticleId',
                    'ArticleQuantity',
                    'ArticleQuantifiedValue',
                    'Unit',
                    'ArticleInternalUnitPrice',
                    'ArticleExternalUnitPrice',
                    'ArticleExternalFinalAmount',
                    'ArticleInternalFinalAmount',
                    'ArticleDiscountPercentageIsAmount',
                    'ArticleDiscountPercentage',
                    'ArticleDiscountFinalAmount',
                    'ArticleExternalFinalAmountIncludingDiscount',
                    'AddKbaseCalculation',
                    'KBaseTwoAmount',
                    'KBaseOneAmount',
                    'Staggering',
                    'AccountingGroup',
                    { DesignationCost: OfferCosts },
                    { SurchargeCosts: OfferCosts },
                    { MaterialCosts: OfferCosts },
                    { FoodCosts: OfferCosts },
                    { TransportationCosts: OfferCosts },
                    { DiverseCosts: OfferCosts },
                    // 'SurchargeInfos',
                    'InternalNote',
                    'CustomerNote',
                    'CantonSurchargeId',
                    'CantonSurcharge',
                    'CantonValues'
                ]
            },
            {
                Materials: [
                    'ArticleId',
                    'AssignmentDate',
                    'Quantity',
                    'ArticleDescription'
                ]
            }
        ],
        OfferInformation: [
            'ItemId',
            'EntityId',
            { BillingAddress: BillingAddress },
            {
                BillingContact: [
                    'ContactInfoId',
                    'PersonId',
                    'Name',
                    'Email',
                    'MobileNumber',
                    'MobileCountryCode'
                ]
            },
            {
                OptionalContact: [
                    'ContactInfoId',
                    'PersonId',
                    'Name',
                    'Email',
                    'MobileNumber',
                    'MobileCountryCode'
                ]
            },
            { OptionalAddress: BillingAddress },
            { Venue: BillingAddress },
            { MeetingPoint: BillingAddress },
            'ValidityDate',
            'Title',
            'ProjectCode',
            'ParkingRegulation',
            { ParkingLocation: BillingAddress },
            'MainEmploymentLocationId',
            { MainEmploymentLocation: BillingAddress },
            'Status',
            'Remark',
            'Comment',
            {
                Terms: [
                    'ItemKey',
                    'Title',
                    `MultipleValues { ItemKey ItemValue IsSelected} `,
                    'SingleValue',
                    'Remark'
                ]
            },
            'IsArchived',
            'RejectionReason',
            'InvoiceFileId',
            'AdministrativeChargePercentage',
            'AdministrativeChargeAmount',
            'TotalVat',
            'Vat',
            'TotalAmount',
            'DiscountAmount',
            'TotalRevenuePercentage',
            { FoodSurcharges: ['ItemKey', 'ItemValue'] },
            'TotalKBaseTwoAmount',
            'TotalRevenueAmount',
            'VatNumber',
            'CantonSurchargeId',
            'CantonSurcharge',
            'TemplateId',
            'Template',
            'StartDateTime',
            'EndDateTime',
            'TotalSurchargeAmountExternal',
            'CreateDate',
            'TemplateDescription',
            'ProjectContactPersonName',
            'ProjectContactPhoneNumber',
            'Tags',
            'ModuleKey',
            'ModuleName',
            'SubTotalAmount',
            'RequiredEmSegmentations',
            'RequiredHrSegmentations',
            'AchievableEmSegmentations',
            'AchievableHrSegmentations',
            'RequiredDocuments',
            'AcademyTrainingFee',
            'HasAllowance',
            'AllowanceAmount',
            'EligibilityDescription',
            'IsPublic',
            'MaterialPackages',
            {
                Manager: [
                    'UserInfoId',
                    'PersonId',
                    'EmployeeId',
                    'Name',
                    'Avatar',
                    'Roles'
                ]
            },
            {
                Planner: [
                    'UserInfoId',
                    'PersonId',
                    'EmployeeId',
                    'Name',
                    'Avatar',
                    'Roles'
                ]
            },
            {
                OfferCreatededBy: [
                    'UserInfoId',
                    'PersonId',
                    'EmployeeId',
                    'Name',
                    'Avatar',
                    'Roles'
                ]
            },
            {
                Client: [
                    'ClientId',
                    'ParentId',
                    'Description',
                    'OrganizationId',
                    'OrganizationName',
                    'EntityId',
                    'Title',
                    'Image',
                    'DisplayTitle'
                ]
            },
            {
                OptionalClient: [
                    'ClientId',
                    'ParentId',
                    'Description',
                    'EntityId',
                    'OrganizationId',
                    'OrganizationName',
                    'Title',
                    'Image',
                    'DisplayTitle'
                ]
            },
            {
                PlanningGroup: [
                    'Title',
                    'EntityId',
                    'Description',
                    'Code',
                    'Image'
                ]
            }
        ],
        ProjectInformation: [
            'ItemId',
            'EntityId',
            { Client: ProjectClientDetail },
            { BillingAddress: BillingAddress },
            { BillingContact: ProjectContactDetail },
            { OptionalClient: ProjectClientDetail },
            { OptionalAddress: BillingAddress },
            { OptionalContact: ProjectContactDetail },
            { PlanningGroup: DeltaCommonInfo },
            'Title',
            { Venue: BillingAddress },
            { MeetingPoint: BillingAddress },
            'ParkingRegulation',
            { ParkingLocation: BillingAddress },
            'MainEmploymentLocationId',
            { MainEmploymentLocation: BillingAddress },
            'ProjectContactPersonName',
            'ProjectContactPhoneNumber',
            'Remark',
            'IsArchived',
            'Status',
            { OfferCreatededBy: UserInfo },
            { Manager: UserInfo },
            { Planner: UserInfo },
            'RejectionReason',
            'InvoiceFileId',
            'AdministrativeChargePercentage',
            'AdministrativeChargeAmount',
            'TotalVat',
            'TotalAmount',
            'DiscountAmount',
            'Vat',
            'TotalRevenuePercentage',
            'TotalKBaseTwoAmount',
            'TotalRevenueAmount',
            'VatNumber',
            'CantonSurchargeId',
            'CantonSurcharge',
            'TemplateId',
            'Template',
            'TemplateDescription',
            { FoodSurcharges: ['ItemKey', 'ItemValue'] },
            'OfferId',
            'IsProjectCritical',
            'ParentProjectId',
            { ProjectKeyStatusList: MultiTypeKeyValue },
            'StartDateTime',
            'StartDateTime_ZoneSpecific',
            'EndDateTime',
            'EndDateTime_ZoneSpecific',
            'Tags'
        ],
        ClientContactPerson: [
            'ItemId',
            'FirstName',
            'CompositeTitle',
            'OriginClientId',
            'LastName',
            'DisplayName',
            'CreateDate',
            'BusinessType',
            'DateOfBirth',
            'SerialNumber',
            'OrganizationId',
            'ParentOrganizationId',
            'ContactType',
            'BillingType',
            'ClientId',
            'ImageId',
            'Website',
            'ClientTags',
            {
                Managers: [
                    'Name',
                    'Role',
                    'PersonId',
                    'ProfileImageId',
                    'SortingOrder'
                ]
            },
            {
                Addresses: BillingAddress.concat(
                    'ClientName',
                    'BranchName',
                    'Tagline',
                    'ClientSignature'
                )
            },
            { PhoneNumbers: ['Type', 'SortingOrder', 'ItemKey', 'ItemValue'] },
            'PersonId',
            'BillingEmail',
            'Email',
            'Tags',
            'ThumbnailImageId',
            'IsActive',
            'Department',
            'PreferredLanguages',
            'OrganizationName',
            'ParentOrganizationName',
            'Designation',
            'Fax',
            'ClientSerialNumber'
        ],
        ClientOrganization: [
            'ItemId',
            'Name',
            'CreateDate',
            'BusinessType',
            'EstablishedOn',
            'SerialNumber',
            'OrganizationType',
            'ParentId',
            'BillingType',
            'ClientId',
            'ImageId',
            'Website',
            'ClientTags',
            {
                Managers: [
                    'Name',
                    'Role',
                    'PersonId',
                    'ProfileImageId',
                    'SortingOrder'
                ]
            },
            {
                Addresses: BillingAddress.concat(
                    'ClientName',
                    'BranchName',
                    'Tagline',
                    'ClientSignature'
                )
            },
            { PhoneNumbers: ['Type', 'SortingOrder', 'ItemKey', 'ItemValue'] },
            'Tags',
            'ThumbnailImageId',
            'IsActive',
            'SortingOrder',
            'ClientSerialNumber'
        ],
        ClientInformation: [
            'ItemId',
            'Tags',
            'CreateDate',
            'Name',
            'BusinessType',
            'SerialNumber',
            'OrganizationType',
            'ContractType',
            'ClientType',
            'ImageId',
            'ThumbnailImageId',
            'IsActive',
            'ClientTags'
        ],
        ProjectProduct: [
            'ItemId',
            'EntityId',
            'ProjectId',
            'DailyProjectId',
            'AssignmentDate',
            'StartDateTime',
            'EndDateTime',
            'StartTime',
            'EndTime',
            'StartTimeInSeconds',
            'EndTimeInSeconds',
            'AssignmentDuration',
            'OverNightJob',
            'MonthName',
            'Month',
            'Year',
            'DepartmentId',
            'Department',
            'WorkDescription',
            { Dress: OfferDressCode },
            'Distance',
            'FoodApplicable',
            'RadioApplicable',
            'BaseArticleId',
            'ItemMasterId',
            'Specification',
            'ArticleCategory',
            'ArticleDescription',
            'ArticleId',
            'ArticleQuantity',
            'ArticleQuantifiedValue',
            'Unit',
            'ArticleInternalUnitPrice',
            'ArticleExternalUnitPrice',
            'ArticleExternalFinalAmount',
            'ArticleInternalFinalAmount',
            'ArticleDiscountPercentageIsAmount',
            'ArticleDiscountPercentage',
            'ArticleDiscountFinalAmount',
            'ArticleExternalFinalAmountIncludingDiscount',
            'AddKbaseCalculation',
            'KBaseTwoAmount',
            'KBaseOneAmount',
            'Staggering',
            'AccountingGroup',
            { DesignationCost: ProductCostDetail },
            { SurchargeCosts: ProductCostDetail },
            { MaterialCosts: ProductCostDetail },
            { FoodCosts: ProductCostDetail },
            { TransportationCosts: ProductCostDetail },
            { DiverseCosts: ProductCostDetail },
            {
                SurchargeInfos: [
                    'ArticleId',
                    'ArticleDescription',
                    'SurchargeType'
                ]
            },
            'InternalNote',
            'CustomerNote',
            'CantonSurchargeId',
            'CantonSurcharge',
            'CantonValues',
            'EmSegmentations',
            'HrSegmentations',
            'Tags',
            'WLRemark'
        ],
        ProductStanding: [
            'ItemId',
            'EntityId',
            'ProjectId',
            'DailyProjectId',
            'AssignmentDate',
            'StartDateTime',
            'EndDateTime',
            'StartTime',
            'EndTime',
            'StartTimeInSeconds',
            'EndTimeInSeconds',
            'AssignmentDuration',
            'OverNightJob',
            'MonthName',
            'Month',
            'Year',
            'DepartmentId',
            'Department',
            'WorkDescription',
            { Dress: OfferDressCode },
            'Distance',
            'FoodApplicable',
            'RadioApplicable',
            'BaseArticleId',
            'ItemMasterId',
            'Specification',
            'ArticleCategory',
            'ArticleDescription',
            'ArticleId',
            'ArticleQuantity',
            'ArticleQuantifiedValue',
            'Unit',
            'ArticleInternalUnitPrice',
            'ArticleExternalUnitPrice',
            'ArticleExternalFinalAmount',
            'ArticleInternalFinalAmount',
            'ArticleDiscountPercentageIsAmount',
            'ArticleDiscountPercentage',
            'ArticleDiscountFinalAmount',
            'ArticleExternalFinalAmountIncludingDiscount',
            'AddKbaseCalculation',
            'KBaseTwoAmount',
            'KBaseOneAmount',
            'Staggering',
            'AccountingGroup',
            { DesignationCost: ProductCostDetail },
            { SurchargeCosts: ProductCostDetail },
            { MaterialCosts: ProductCostDetail },
            { FoodCosts: ProductCostDetail },
            { TransportationCosts: ProductCostDetail },
            { DiverseCosts: ProductCostDetail },
            {
                SurchargeInfos: [
                    'ArticleId',
                    'ArticleDescription',
                    'SurchargeType'
                ]
            },
            'InternalNote',
            'CustomerNote',
            'CantonSurchargeId',
            'CantonSurcharge',
            'CantonValues',
            'EmSegmentations',
            'HrSegmentations',
            'ProductId',
            'EmployeeId',
            'PersonId',
            'ContactId',
            'DisplayName',
            'ProfileImageId',
            'EmployeeCategory',
            'AssigneeId',
            'MaterialId',
            'OnsiteStatus',
            'EORTPlace',
            'DepartureDateTime',
            'DepartureDateTime_ZoneSpecific',
            'DepartureTime',
            'DepartureTimeInSeconds',
            'BoardingPlaceId',
            'BoardingPlace',
            'BoardingDateTime',
            'BoardingDateTime_ZoneSpecific',
            'BoardingTime',
            'BoardingTimeInSeconds',
            'Tags',
            'Einsatz',
            'CertificateFileId',
            'IsProjectLeader',
            'IsPresent',
            { BreakTimeSpans: ['StartTimeInSeconds', 'EndTimeInSeconds'] },
            'Comment',
            'IsCertified'
        ],
        ProductStandingTrainingReport: [
            'ItemId',
            'EntityId',
            'ProjectId',
            'DailyProjectId',
            'AssignmentDate',
            'StartDateTime',
            'EndDateTime',
            'StartTime',
            'EndTime',
            'StartTimeInSeconds',
            'EndTimeInSeconds',
            'ContactId',
            'DisplayName',
            'ProfileImageId',
            'Tags',
            'Einsatz'
        ],
        DailyProjectInformationScrumboard: [
            'id: ItemId',
            'name: Title',
            'EntityId',
            { Client: ProjectClientDetail },
            { BillingAddress: BillingAddress },
            { BillingContact: ProjectContactDetail },
            { OptionalClient: ProjectClientDetail },
            { OptionalAddress: BillingAddress },
            { OptionalContact: ProjectContactDetail },
            { PlanningGroup: DeltaCommonInfo },
            { Venue: BillingAddress },
            { MeetingPoint: BillingAddress },
            'ParkingRegulation',
            { ParkingLocation: BillingAddress },
            'MainEmploymentLocationId',
            { MainEmploymentLocation: BillingAddress },
            'ProjectContactPersonName',
            'ProjectContactPhoneNumber',
            'Remark',
            'Comment',
            'IsArchived',
            'Status',
            { OfferCreatededBy: UserInfo },
            { Manager: UserInfo },
            { Planner: UserInfo },
            'RejectionReason',
            'InvoiceFileId',
            'AdministrativeChargePercentage',
            'AdministrativeChargeAmount',
            'TotalVat',
            'TotalAmount',
            'DiscountAmount',
            'Vat',
            'TotalRevenuePercentage',
            'TotalKBaseTwoAmount',
            'TotalRevenueAmount',
            'VatNumber',
            'CantonSurchargeId',
            'CantonSurcharge',
            'TemplateId',
            'Template',
            'TemplateDescription',
            { FoodSurcharges: ['ItemKey', 'ItemValue'] },
            'ProjectType',
            'ProjectDates',
            'ProjectMonths',
            'ProjectYears',
            'OfferId',
            'IsProjectCritical',
            'ParentProjectId',
            { ProjectKeyStatusList: MultiTypeKeyValue },
            {
                Terms: [
                    'ItemKey',
                    'Title',
                    `MultipleValues { ItemKey ItemValue IsSelected} `,
                    'SingleValue',
                    'Remark'
                ]
            },
            'AssignmentDate',
            'StartDateTime',
            'EndDateTime',
            'StartTime',
            'EndTime',
            'StartTimeInSeconds',
            'EndTimeInSeconds',
            'AssignmentDuration',
            'OverNightJob',
            'MonthName',
            'Month',
            'Year',
            'InternalDocIdList',
            'ExternalDocIdList',
            'RequiredDocuments',
            'AcademyTrainingFee',
            'IsPublic',
            'EligibilityDescription',
            'Tags'
        ],
        DailyProjectInformationEmployee: [
            'ItemId',
            'Title',
            { Venue: BillingAddress },
            { PlanningGroup: DeltaCommonInfo },
            'StartDateTime',
            'EndDateTime',
            'StartTime',
            'EndTime'
        ],
        DailyProjectInformation: [
            'ItemId',
            'EntityId',
            { ReportStatuses: ['ItemKey', 'ItemValue'] },
            { Client: ProjectClientDetail },
            { BillingAddress: BillingAddress },
            { BillingContact: ProjectContactDetail },
            { OptionalClient: ProjectClientDetail },
            { OptionalAddress: BillingAddress },
            { OptionalContact: ProjectContactDetail },
            { PlanningGroup: DeltaCommonInfo },
            'Title',
            { Venue: BillingAddress },
            { MeetingPoint: BillingAddress },
            'ParkingRegulation',
            { ParkingLocation: BillingAddress },
            'MainEmploymentLocationId',
            { MainEmploymentLocation: BillingAddress },
            'ProjectContactPersonName',
            'ProjectContactPhoneNumber',
            'Remark',
            'Comment',
            'IsArchived',
            'Status',
            { OfferCreatededBy: UserInfo },
            { Manager: UserInfo },
            { Planner: UserInfo },
            'RejectionReason',
            'InvoiceFileId',
            'AdministrativeChargePercentage',
            'AdministrativeChargeAmount',
            'TotalVat',
            'TotalAmount',
            'DiscountAmount',
            'Vat',
            'TotalRevenuePercentage',
            'TotalKBaseTwoAmount',
            'TotalRevenueAmount',
            'VatNumber',
            'CantonSurchargeId',
            'CantonSurcharge',
            'TemplateId',
            'Template',
            'TemplateDescription',
            { FoodSurcharges: ['ItemKey', 'ItemValue'] },
            'ProjectType',
            'ProjectDates',
            'ProjectMonths',
            'ProjectYears',
            'OfferId',
            'IsProjectCritical',
            'ParentProjectId',
            { ProjectKeyStatusList: MultiTypeKeyValue },
            {
                Terms: [
                    'ItemKey',
                    'Title',
                    `MultipleValues { ItemKey ItemValue IsSelected} `,
                    'SingleValue',
                    'Remark'
                ]
            },
            'AssignmentDate',
            'StartDateTime',
            'EndDateTime',
            'StartTime',
            'EndTime',
            'StartTimeInSeconds',
            'EndTimeInSeconds',
            'AssignmentDuration',
            'OverNightJob',
            'MonthName',
            'Month',
            'Year',
            'InternalDocIdList',
            'ExternalDocIdList',
            'RequiredEmSegmentations',
            'RequiredHrSegmentations',
            'AchievableEmSegmentations',
            'AchievableHrSegmentations',
            'RequiredDocuments',
            'AcademyTrainingFee',
            'HasAllowance',
            'AllowanceAmount',
            'EligibilityDescription',
            'IsPublic',
            'MaterialPackages',
            'ModuleKey',
            'ModuleName',
            'WishlistDeadline',
            'Tags',
            'ValidityDate',
            'LastUpdateDate',
            'IsProjectRecurring',
            'DocumentFolderId'
        ],
        DailyProjectInformationAcademyList: [
            'ItemId',
            'EntityId',
            { Client: ProjectClientDetail },
            { PlanningGroup: DeltaCommonInfo },
            'Title',
            { Venue: BillingAddress },
            'Status',
            'ProjectType',
            'AssignmentDate',
            'StartDateTime',
            'EndDateTime',
            'StartTime',
            'EndTime',
            'StartTimeInSeconds',
            'EndTimeInSeconds',
            'Tags'
        ],
        OfferProduct: [
            'ItemId',
            'EntityId',
            'ProjectId',
            'AssignmentDate',
            'StartDateTime',
            'EndDateTime',
            'StartTime',
            'EndTime',
            'StartTimeInSeconds',
            'EndTimeInSeconds',
            'WorkDescription',
            'OverNightJob',
            'DepartmentId',
            'Department',
            { Dress: OfferDressCode },
            {
                SurchargeInfos: [
                    'ArticleId',
                    'ArticleDescription',
                    'SurchargeType'
                ]
            },
            'Distance',
            'FoodApplicable',
            'RadioApplicable',
            'ItemMasterId',
            'Specification',
            'ArticleCategory',
            'ArticleDescription',
            'ArticleId',
            'ArticleQuantity',
            'ArticleQuantifiedValue',
            'Unit',
            'ArticleInternalUnitPrice',
            'ArticleExternalUnitPrice',
            'ArticleExternalFinalAmount',
            'ArticleInternalFinalAmount',
            'ArticleDiscountPercentageIsAmount',
            'ArticleDiscountPercentage',
            'ArticleDiscountFinalAmount',
            'ArticleExternalFinalAmountIncludingDiscount',
            'AddKbaseCalculation',
            'KBaseTwoAmount',
            'KBaseOneAmount',
            'Staggering',
            'AccountingGroup',
            { DesignationCost: OfferCosts },
            { SurchargeCosts: OfferCosts },
            { MaterialCosts: OfferCosts },
            { FoodCosts: OfferCosts },
            { TransportationCosts: OfferCosts },
            { DiverseCosts: OfferCosts },
            // 'SurchargeInfos',
            'InternalNote',
            'CustomerNote',
            'CantonSurchargeId',
            'CantonSurcharge',
            'CantonValues',
            'Tags'
        ],
        ArticleMaterial: ['ItemId', 'ArticleId', 'Title'],
        OfferMaterial: [
            'ItemId',
            'ArticleId',
            'AssignmentDate',
            'PackageId',
            'Quantity',
            'ArticleDescription'
        ],
        ProjectMaterial: [
            'ItemId',
            'ProjectId',
            'DailyProjectId',
            'ArticleId',
            'ArticleDescription',
            'PackageId',
            'AssignmentDate',
            'Quantity',
            'Tags'
        ],
        WorkableSchedule: [
            'ItemId',
            'CommandId',
            'PersonId',
            'UserId',
            'EmployeeId',
            'DisplayName',
            'ProfileImageId',
            'EmployeeCategory',
            { PrimaryWorkplace: AddressInfo },
            { SecondaryWorkplace: AddressInfo },
            'PhoneNumber',
            'Email',
            'EmSegmentations',
            'HrSegmentations',
            { Schedules: WorkableProductInformation },
            'Tags'
        ],
        ProductAssignment: [
            'ItemId',
            'ProjectId',
            'DailyProjectId',
            'ProductId',
            'ArticleId',
            'ArticleDescription',
            'EmployeeId',
            'PersonId',
            'CustomerId',
            'DisplayName',
            'ProfileImageId',
            'Status',
            'AssignmentState',
            'Staggering',
            'Remark',
            'InvitationDate',
            'AcceptDate',
            'RejectionDate',
            'RejectionReason',
            'ConfirmationDate',
            'WishlistDeadline',
            'IsExtraRequested',
            'PrimaryWorkplaceId',
            { PrimaryWorkplace: AddressInfo },
            'SecondaryWorkplaceId',
            { SecondaryWorkplace: AddressInfo },
            { Scores: IndividualScore },
            'OverNightJob',
            'AssignmentDate',
            'AssignmentDate_ZoneSpecific',
            'StartDateTime',
            'EndDateTime',
            'StartDateTime_ZoneSpecific',
            'EndDateTime_ZoneSpecific',
            'StartTime',
            'EndTime',
            'StartTimeInSeconds',
            'EndTimeInSeconds',
            'AssignmentDuration',
            'TimeZoneInMinute',
            'MonthName',
            'Month',
            'Year',
            'Tags',
            'Remark'
        ],
        PaymentBasicInformation: [
            'ItemId',
            'CreateDate',
            'EventTitle',
            'EventId',
            'EventType',
            'EventStandingId',
            'PaymentDetailId',
            'PersonId',
            'CustomerId',
            'EmployeeId',
            'Status',
            'PayableAmount',
            'Amount',
            'DiscountAmount',
            'SubscriptionId',
            'Currency',
            'PaymentDate',
            'ActionDate',
            'Fileids',
            'IsArchived',
            'Tags',
            'RequestedFiles',
            'RequesterPersonId',
            'RequesterUserId',
            'IsRequestedFilesSubmitted',
            'IsValidPayment'
        ],
        PaymentByMonth: [
            'ItemId',
            'Tags',
            'EmployeeId',
            'PersonId',
            'Month',
            'Year',
            'TotalHour',
            'TargetHourPerDay',
            'TargetHourPerMonth',
            'HourlyRate',
            'MonthlyRate',
            'TotalAmount',
            'Lohnmandant',
            'PayrollPdfFileId',
            'TotalExpenses',
            'FixedSalary',
            'WorkingHour',
            'SickLeaveHour',
            'AccidentalLeaveHour',
            'PaidLeaveHour',
            'MilitaryLeaveHour',
            'ExtraHourManualCorrection'
        ],
        ProductStandingReportInfo: [
            'ItemId',
            'CreateDate',
            'Score',
            'QalificationReportStatus',
            'QalificationReportActionDate',
            'QalificationReportActionBy',
            'TrainingReportStatus',
            'TrainingReportActionDate',
            'TrainingReportActionBy',
            'IsPassed',
            'Language',
            'Tags',
            'ProductStandingId'
        ],
        QualificationReport: [
            'ItemId',
            // 'CreateDate',
            'PersonId',
            'ProductStandingId',
            'DailyProjectId',
            'QualificationKey',
            'QualificationTitle',
            'QualificationType',
            'Answer',
            'AnswerValue',
            'Remark',
            'Language',
            'Tags'
        ],
        ProjectModule: [
            'ItemId',
            'Title',
            'Description',
            'QualificationKeys',
            'Tags'
        ],
        QualificationMatrix: [
            'ItemId',
            'Title',
            'Description',
            'Type',
            'ModuleKeys',
            'SortingOrder',
            'Tags'
        ],
        EmployeeProfileInfo: [
            'ItemId',
            'Language',
            'Tags',
            'IsMarkedToDelete',
            'EmployeeId',
            'Email',
            'Street',
            'PostalCode',
            'City',
            'BankName',
            'BankAccountOwner',
            'IBAN',
            'CurrentOccupation',
            'EmergencyContact',
            'EmergencyMobileNo',
            'EmergencyEmail',
            'EmergencyContactRelation',
            'EmergencyAddress',
            'PhoneNumber',
            'ProfileImageId'
        ],
        InventoryTransaction: [
            'CreateDate',
            'CreatedBy',
            'DailyProjectId',
            'IsCompleted',
            'IsMarkedToDelete',
            'ItemId',
            'LastUpdateDate',
            'LastUpdatedBy',
            'ProjectId',
            'ProjectTitle',
            { TransactedBy: TransactionInfo },
            { TransactedTo: TransactionInfo },
            'TransactionCategory',
            'TransactionCompletionDate',
            'TransactionDate',
            'TransactionItemType',
            'TransactionStatus',
            'TransactionType',
            'WarehouseId',
            'WarehouseKey',
            'WarehouseName',
            'Tags',
            'ProjectInventoryStatus',
            {TransferHistories:
                TransferHistories }
        ],
        InventoryTransactionItem: [
            'ItemId',
            'TransactionStatus',
            'IsCompleted',
            'TransactionCompletionDate',
            'ArticleId',
            'DailyProjectId',
            'InventoryItemId',
            'InventoryItemName',
            'InventoryPackageId',
            'InventoryPackageName',
            'RequiredQuantity',
            'IsRented',
            'Quantity',
            'ItemCodes',
            { TransactionTo: TransactionInfo },
            'TransactionId',
            'TransactionQuantity'
        ]
    },

    PriorityLevel: [
        {
            id: '3',
            name: 'HIGH',
            color: 'red-500'
        },
        {
            id: '2',
            name: 'MEDIUM',
            color: 'orange-400'
        },
        {
            id: '1',
            name: 'LOW',
            color: 'blue-600'
        }
    ],
    QuestionTypes: [
        {
            Key: 'multiple-choice',
            Value: 'Multiple Choice',
            Icon: 'radio_button_checked',
            langKey: 'MULTIPLE_CHOICE'
        },
        {
            Key: 'checkbox',
            Value: 'Checkboxes',
            Icon: 'check_box',
            langKey: 'CHECKBOXES'
        },
        {
            Key: 'short-text',
            Value: 'Short Text',
            Icon: 'sort',
            langKey: 'SHORT_TEXT'
        }
    ],
    PassedPercentage: 40,
    MaxQuizAttempt: 2,
    QuizStatus: {
        Passed: {
            Key: 'PASSED',
            Value: 'Passed'
        },
        Failed: {
            Key: 'FAILED',
            Value: 'Failed'
        },
        Pending: {
            Key: 'PENDING',
            Value: 'Pending'
        },
        Due: {
            Key: 'DUE',
            Value: 'Due'
        }
    },
    QuizView: {
        ResultView: 'result-view',
        QuestionView: 'question-view'
    },
    CourseResult: {
        Completed: 'Completed',
        Pending: 'Pending'
    }
};
